import * as s from "react";
import t, { useState as w, useEffect as x, createContext as nt, forwardRef as st, useRef as K, useContext as kt, useCallback as me, useMemo as re } from "react";
import { Button as ye, useDisclosureStore as mt, Disclosure as rt, DisclosureContent as yt, Checkbox as ce, useDialogStore as ge, Dialog as pe, SelectItem as ue, useSelectStore as de, Select as he, SelectPopover as _e, useRadioStore as be, RadioGroup as Ce, Radio as ve } from "@ariakit/react";
function Ee(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var wt = {
  exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function (e) {
  (function () {
    var o = {}.hasOwnProperty;
    function i() {
      for (var l = [], a = 0; a < arguments.length; a++) {
        var n = arguments[a];
        if (n) {
          var r = typeof n;
          if (r === "string" || r === "number") l.push(n);else if (Array.isArray(n)) {
            if (n.length) {
              var g = i.apply(null, n);
              g && l.push(g);
            }
          } else if (r === "object") {
            if (n.toString !== Object.prototype.toString && !n.toString.toString().includes("[native code]")) {
              l.push(n.toString());
              continue;
            }
            for (var y in n) o.call(n, y) && n[y] && l.push(y);
          }
        }
      }
      return l.join(" ");
    }
    e.exports ? (i.default = i, e.exports = i) : window.classNames = i;
  })();
})(wt);
var fe = wt.exports;
const c = /* @__PURE__ */Ee(fe),
  ke = e => /* @__PURE__ */s.createElement("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#161617"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M15.942 6.375C10.6605 6.375 6.37695 10.5831 6.37695 15.7733C6.37695 19.9258 9.11735 23.4485 12.9187 24.6915C13.3961 24.7784 13.5508 24.4871 13.5508 24.2396V22.4899C10.8901 23.0585 10.3361 21.3809 10.3361 21.3809C9.90089 20.2946 9.27358 20.0056 9.27358 20.0056C8.40555 19.4222 9.33974 19.4347 9.33974 19.4347C10.3002 19.5005 10.8056 20.4035 10.8056 20.4035C11.6585 21.8399 13.043 21.4248 13.589 21.1843C13.6743 20.5774 13.9222 20.1623 14.1964 19.9281C12.0722 19.6892 9.83872 18.8833 9.83872 15.283C9.83872 14.2562 10.2126 13.4182 10.8239 12.7603C10.7251 12.523 10.3975 11.5668 10.9172 10.2729C10.9172 10.2729 11.7207 10.0207 13.5484 11.2363C14.3112 11.0279 15.129 10.9238 15.942 10.9199C16.7551 10.9238 17.5737 11.0279 18.3381 11.2363C20.1642 10.0207 20.9661 10.2729 20.9661 10.2729C21.4866 11.5676 21.159 12.5238 21.0602 12.7603C21.6739 13.4182 22.0446 14.257 22.0446 15.283C22.0446 18.8927 19.8071 19.6877 17.6773 19.9203C18.0201 20.2116 18.3333 20.7833 18.3333 21.6605V24.2396C18.3333 24.4894 18.4864 24.7831 18.9718 24.6907C22.7699 23.4462 25.5071 19.9242 25.5071 15.7733C25.5071 10.5831 21.2244 6.375 15.942 6.375Z",
    fill: "white"
  })),
  ut = e => /* @__PURE__ */s.createElement("svg", {
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 30",
    style: {
      enableBackground: "new 0 0 142 30"
    },
    xmlSpace: "preserve",
    ...e
  }, /* @__PURE__ */s.createElement("title", null, "IMG.LY"), /* @__PURE__ */s.createElement("path", {
    className: "st0",
    d: "M0.4,29h8.4V1H0.4V29z M46.5,1H36.2l-6,18.1L24.3,1H13.7v28h8.1V11.6L27.2,29h6.2l5.1-17.4V29h8.1V1z M66,19 h4.6c-0.4,2.2-2.2,4-5.3,4c-4.6,0-6.8-3.4-6.8-7.8c0-4,1.8-7.8,6.3-7.8c2.9,0,4.5,1.8,4.8,3.4h9.2C78.3,5,73.1,0.2,64.9,0.2 c-9.4,0-14.9,7.1-14.9,14.8c0,8,5.3,14.8,14.9,14.8c8.2,0,13.1-4.4,14.1-10.8h2.7v-5.5H66V19z M105.9,21.9V1h-8.3v28h15.6v-7.1 H105.9z M141.9,1h-9.3l-4.2,10l-4.5-10h-9.8l9.4,18.1l-4.8,9.9h9.4L141.9,1z",
    fill: "#FFFFFF"
  }), /* @__PURE__ */s.createElement("path", {
    className: "st1",
    d: "M83.8,24.7c0,2.6,2.1,4.8,4.8,4.8c2.8,0,4.9-2.2,4.9-4.8s-2.1-4.8-4.9-4.8C85.9,19.9,83.8,22,83.8,24.7z",
    fill: "#471AFF"
  })),
  we = e => /* @__PURE__ */s.createElement("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("ellipse", {
    cx: 15.9996,
    cy: 15.9996,
    rx: 14.4,
    ry: 14.4,
    fill: "white"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M19.772 8.40267C18.788 8.35733 18.492 8.34933 16 8.34933C13.508 8.34933 13.2133 8.35867 12.2293 8.40267C9.69733 8.51867 8.51867 9.71733 8.40267 12.2293C8.35867 13.2133 8.348 13.508 8.348 16C8.348 18.492 8.35867 18.7867 8.40267 19.772C8.51867 22.2773 9.692 23.4827 12.2293 23.5987C13.212 23.6427 13.508 23.6533 16 23.6533C18.4933 23.6533 18.788 23.644 19.772 23.5987C22.304 23.484 23.4813 22.2813 23.5987 19.772C23.6427 18.788 23.652 18.492 23.652 16C23.652 13.508 23.6427 13.2133 23.5987 12.2293C23.4813 9.71867 22.3013 8.51867 19.772 8.40267ZM16 20.7933C13.3533 20.7933 11.2067 18.648 11.2067 16C11.2067 13.3533 13.3533 11.208 16 11.208C18.6467 11.208 20.7933 13.3533 20.7933 16C20.7933 18.6467 18.6467 20.7933 16 20.7933ZM20.9827 12.1387C20.364 12.1387 19.8627 11.6373 19.8627 11.0187C19.8627 10.4 20.364 9.89867 20.9827 9.89867C21.6013 9.89867 22.1027 10.4 22.1027 11.0187C22.1027 11.636 21.6013 12.1387 20.9827 12.1387ZM19.1107 16C19.1107 17.7187 17.7173 19.1107 16 19.1107C14.2827 19.1107 12.8893 17.7187 12.8893 16C12.8893 14.2813 14.2827 12.8893 16 12.8893C17.7173 12.8893 19.1107 14.2813 19.1107 16ZM16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM25.2773 19.848C25.124 23.2413 23.2347 25.1213 19.8493 25.2773C18.8533 25.3227 18.5347 25.3333 16 25.3333C13.4653 25.3333 13.148 25.3227 12.152 25.2773C8.76 25.1213 6.87867 23.2387 6.72267 19.848C6.67733 18.8533 6.66667 18.5347 6.66667 16C6.66667 13.4653 6.67733 13.148 6.72267 12.152C6.87867 8.76 8.76133 6.87867 12.152 6.724C13.148 6.67733 13.4653 6.66667 16 6.66667C18.5347 6.66667 18.8533 6.67733 19.8493 6.724C23.2427 6.88 25.1253 8.76667 25.2773 12.152C25.3227 13.148 25.3333 13.4653 25.3333 16C25.3333 18.5347 25.3227 18.8533 25.2773 19.848Z",
    fill: "#161617"
  })),
  xe = e => /* @__PURE__ */s.createElement("svg", {
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("ellipse", {
    cx: 16.3411,
    cy: 15.9414,
    rx: 14.7063,
    ry: 14.3476,
    fill: "white"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M16 0C7.164 0 0 7.164 0 16C0 24.836 7.164 32 16 32C24.836 32 32 24.836 32 16C32 7.164 24.836 0 16 0ZM13.3333 21.3333H10.6667V13.3333H13.3333V21.3333ZM12 12.1453C11.1907 12.1453 10.5333 11.484 10.5333 10.6667C10.5333 9.85067 11.1893 9.188 12 9.188C12.8107 9.188 13.4667 9.85067 13.4667 10.6667C13.4667 11.484 12.8093 12.1453 12 12.1453ZM22.6667 21.3333H20.0027V17.5187C20.0027 15.0107 17.3333 15.2227 17.3333 17.5187V21.3333H14.6667V13.3333H17.3333V14.7907C18.496 12.636 22.6667 12.476 22.6667 16.8547V21.3333Z",
    fill: "#161617"
  })),
  Le = e => /* @__PURE__ */s.createElement("svg", {
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M11.0343 10.6221L4.33141 2.99841H5.91922L11.7418 9.61659L16.3889 2.99841H21.75L14.7212 13.0072L21.75 21.0008H20.1622L14.0173 14.0103L9.10866 21.0008H3.74753M19.5891 4.16999H17.1498L5.92042 19.8868H8.36036",
    fill: "white"
  })),
  Se = "imgly_a795b",
  Ne = {
    root: Se
  },
  D = _ref => {
    let {
      className: e,
      children: o,
      ...i
    } = _ref;
    return /* @__PURE__ */t.createElement("ul", {
      ...i,
      className: c(e, Ne.root)
    }, o);
  },
  Ie = "imgly_c4948",
  Me = {
    root: Ie
  },
  _ = _ref2 => {
    let {
      className: e,
      children: o,
      ...i
    } = _ref2;
    return /* @__PURE__ */t.createElement("li", {
      ...i,
      className: c(e, Me.root),
      tabIndex: 0
    }, o);
  },
  xt = {
    // This value will either display or hide the "Hiring" and "Remote works! Join us." banner.
    hiring: !0
  },
  He = "imgly-website-components-header",
  $e = "imgly-website-components-footer",
  F = {
    pesdk: "PESDKDocs",
    vesdk: "VESDKDocs",
    cesdk: "CESDKDocs",
    pricing: "Pricing",
    contactSales: "ContactSales",
    freeTrial: "FreeTrial",
    faq: "FAQ",
    instagram: "Instagram",
    linkedIn: "LinkedIn",
    twitter: "Twitter",
    github: "GitHub",
    showcases: "Showcases"
  },
  De = {
    name: "IMG.LY",
    url: "https://img.ly/"
  },
  Ve = {
    name: "Support",
    url: "https://img.ly/support"
  },
  Pe = {
    name: "Visit our Support Desk",
    url: "https://img.ly/support"
  },
  Lt = {
    name: "Pricing",
    url: "https://img.ly/pricing",
    analyticsID: F.pricing
  },
  St = {
    name: "Blog",
    url: "https://img.ly/blog/"
  },
  Ae = {
    name: "Get in Touch",
    url: "https://img.ly/forms/contact-sales",
    analyticsID: F.contactSales
  },
  Fe = {
    name: "Free Trial",
    url: "https://img.ly/forms/free-trial",
    analyticsID: F.freeTrial
  },
  Re = {
    name: "Showcases",
    url: "https://img.ly/showcases/cesdk",
    analyticsID: F.showcases
  },
  Nt = {
    name: "Careers",
    url: "https://img.ly/company/careers"
  },
  It = {
    name: "Terms",
    url: "https://img.ly/tos"
  },
  Mt = {
    name: "Privacy Policy",
    url: "https://img.ly/privacy-policy"
  },
  Ht = {
    name: "PhotoEditor SDK",
    description: "PhotoEditor SDK for Web & Mobile",
    url: "https://img.ly/products/photo-sdk"
  },
  $t = {
    name: "VideoEditor SDK",
    description: "VideoEditor SDK for iOS, Android, and React Native",
    url: "https://img.ly/products/video-sdk"
  },
  Dt = {
    name: "CreativeEditor SDK",
    description: "Empower your users to design anything",
    url: "https://img.ly/products/creative-sdk"
  },
  Vt = {
    name: "Camera SDK",
    description: "",
    url: "https://img.ly/products/camera-sdk"
  },
  Ze = {
    name: "Apparel",
    url: "https://img.ly/use-cases/apparel"
  },
  Te = {
    name: "Postcard Editor",
    url: "https://img.ly/use-cases/postcard"
  },
  Be = {
    name: "Poster Editor",
    url: "https://img.ly/use-cases/poster"
  },
  Ge = {
    name: "Greeting Card Editor",
    url: "https://img.ly/use-cases/greeting-card"
  },
  Ke = {
    name: "Photobook Editor",
    url: "https://img.ly/use-cases/photo-book"
  },
  Pt = {
    name: "Variable Data Printing",
    url: "https://img.ly/use-cases/variable-data-printing"
  },
  At = {
    name: "Creative Automation",
    url: "https://img.ly/use-cases/creative-automation"
  },
  Ft = {
    name: "Print Personalization",
    url: "https://img.ly/use-cases/print-personalization"
  },
  Rt = {
    name: "Stories & Reels",
    url: "https://img.ly/use-cases/story-reels-short-video-creation"
  },
  Ue = {
    name: "Print Service Providers",
    url: "https://img.ly/use-cases/photo-prints"
  },
  Oe = {
    name: "Ad Tech",
    url: "https://img.ly/use-cases/story-reels-short-video-creation"
  },
  je = {
    name: "Email Marketing",
    url: "https://img.ly/use-cases/photo-prints"
  },
  Zt = {
    name: "Photo Prints",
    url: "https://img.ly/use-cases/photo-prints"
  },
  Tt = {
    name: "Web-to-Print Design Tool",
    url: "https://img.ly/use-cases/web-to-print-design-tool"
  },
  We = {
    name: "Video Editor for Web",
    url: "https://img.ly/use-cases/video-editor-for-web"
  },
  Bt = {
    name: "Print",
    url: "https://img.ly/industries/print"
  },
  Gt = {
    name: "Marketing Tech",
    url: "https://img.ly/industries/marketing-tech"
  },
  Kt = {
    name: "DAM",
    url: "https://img.ly/industries/digital-asset-management"
  },
  Ut = {
    name: "Social Media",
    url: "https://img.ly/industries/social-media"
  },
  Ot = {
    name: "Brands and Agencies",
    url: "https://img.ly/industries/brands-agencies"
  },
  jt = {
    name: "Website Builder",
    url: "https://img.ly/industries/website-builder"
  },
  Wt = {
    name: "E-Learning",
    url: "https://img.ly/industries/e-learning"
  },
  ct = {
    name: "AI Editor",
    url: "https://img.ly/use-cases/ai-editor"
  },
  zt = {
    name: "E-Commerce",
    url: "https://img.ly/industries/e-commerce"
  },
  ze = {
    name: "Default UI",
    url: "https://img.ly/showcases/cesdk/default-ui/web"
  },
  Ye = {
    name: "Video UI",
    url: "https://img.ly/showcases/cesdk/video-ui/web"
  },
  qe = {
    name: "Apparel UI",
    url: "https://img.ly/showcases/cesdk/apparel-editor-ui/web"
  },
  Je = {
    name: "Automated Resizing ",
    url: "https://img.ly/showcases/cesdk/automated-resizing/web"
  },
  Qe = [
  // first item is the title
  {
    name: "PhotoEditor SDK",
    url: null
  }, {
    name: "Get Started",
    url: "https://img.ly/docs/pesdk/"
  }, {
    name: "Guides",
    url: "https://img.ly/docs/pesdk/guides/"
  }, {
    name: "Frameworks",
    url: "https://img.ly/docs/pesdk/quickstarts/"
  }, {
    name: "API Reference",
    url: "https://img.ly/docs/pesdk/apidocs/"
  }],
  Xe = [{
    name: "VideoEditor SDK",
    url: null
  }, {
    name: "Get Started",
    url: "https://img.ly/docs/vesdk/"
  }, {
    name: "Guides",
    url: "https://img.ly/docs/vesdk/guides/"
  }, {
    name: "Frameworks",
    url: "https://img.ly/docs/vesdk/quickstarts/"
  }, {
    name: "API Reference",
    url: "https://img.ly/docs/vesdk/apidocs/"
  }],
  tl = [{
    name: "CreativeEditor SDK",
    url: null
  }, {
    name: "Get Started",
    url: "https://img.ly/docs/cesdk/"
  }, {
    name: "Guides",
    url: "https://img.ly/docs/cesdk/platforms/"
  }, {
    name: "Frameworks",
    url: "https://img.ly/docs/cesdk/frameworks/"
  }],
  el = [{
    name: "Camera SDK",
    url: null
  }, {
    name: "Get Started",
    url: "https://img.ly/docs/cesdk/mobile-camera/"
  }, {
    name: "Guides",
    url: "https://img.ly/docs/cesdk/mobile-camera/quickstart/"
  }],
  ll = {
    cesdk: tl,
    camerasdk: el,
    vesdk: Xe,
    pesdk: Qe
  },
  ol = [{
    name: "Blog",
    url: "https://img.ly/blog/"
  }, {
    name: "Case Studies",
    url: "https://img.ly/case-studies"
  }, {
    name: "White Papers",
    url: "https://img.ly/white-papers"
  }, {
    name: "Templates",
    url: "https://img.ly/templates"
  }, {
    name: "Partners",
    url: "https://img.ly/partners"
  }, {
    name: "Customers",
    url: "https://img.ly/customers"
  }, {
    name: "Support",
    url: "https://img.ly/support"
  }, {
    name: "What's New",
    url: "https://img.ly/whats-new"
  }, {
    name: "More Use Cases",
    url: "https://img.ly/implement"
  }],
  il = {
    url: "https://img.ly/blog/ghost/api/v3/content/posts/?key=9c48b38d1b39d764598ea879a0"
  },
  al = [ze, Ye, qe, Je],
  nl = [{
    name: "About Us",
    url: "https://img.ly/company"
  }, {
    name: "Team",
    url: "https://img.ly/company/team"
  }, Nt, {
    name: "Contact Us",
    url: "https://img.ly/company/contact-us"
  }],
  sl = [It, {
    name: "Imprint",
    url: "https://img.ly/imprint"
  }, Mt, {
    name: "Acknowledgements",
    url: "https://img.ly/acknowledgements"
  }],
  ml = [Dt, Ht, $t, Vt],
  rl = [Bt, Gt, Kt, zt, Wt, ct, Ut, Ot, jt],
  yl = [ct, Pt, At, Ft, Ze, Ge, Te, Be, Ke, Rt, Tt, Zt],
  cl = [{
    name: "Canva",
    url: "https://img.ly/canva-alternative"
  }, {
    name: "Shotstack",
    url: "https://img.ly/shotstack-alternative"
  }, {
    name: "Banuba",
    url: "https://img.ly/banuba-alternative"
  }, {
    name: "Konva.js",
    url: "https://img.ly/konvajs-alternative"
  }, {
    name: "Polotno",
    url: "https://img.ly/polotno-alternative"
  }, {
    name: "Pixel SDK",
    url: "https://img.ly/pixelsdk-alternative"
  }],
  gl = [Lt, Ve, {
    name: "Sign-In",
    url: "https://img.ly/login"
  }, {
    name: "FAQ's",
    url: "https://img.ly/pricing#faqs",
    analyticsID: F.faq
  }, St, {
    name: "Templates",
    url: "https://img.ly/templates"
  }, {
    name: "Case Studies",
    url: "https://img.ly/case-studies"
  }, {
    name: "White Papers",
    url: "https://img.ly/white-papers"
  }, {
    name: "More Use Cases",
    url: "https://img.ly/implement"
  }, {
    name: "What's New",
    url: "https://img.ly/whats-new"
  }, {
    name: "Getty Images Library SDK",
    url: "https://img.ly/partners/getty-images-sdk"
  }, {
    name: "Soundstripe Partnership",
    url: "https://img.ly/partners/soundstripe"
  }, {
    name: "Customers",
    url: "https://img.ly/customers"
  }, {
    name: "Aviary Alternative",
    url: "https://img.ly/imgly-aviary-comparison"
  }],
  m = {
    IMGLY: De,
    PESDK: Ht,
    VESDK: $t,
    CESDK: Dt,
    CameraSDK: Vt,
    ContactSupport: Pe,
    Pricing: Lt,
    Blog: St,
    ContactSales: Ae,
    FreeTrial: Fe,
    CompanyItems: nl,
    ResourceItems: gl,
    LegalItems: sl,
    GuidesDeveloperLinks: ll,
    Showcases: Re,
    PrintIndustry: Bt,
    MarketingTechIndustry: Gt,
    DAMIndustry: Kt,
    SocialMediaIndustry: Ut,
    BrandAgenciesIndustry: Ot,
    WebsiteBuilderIndustry: jt,
    VariableDataPrintingUseCase: Pt,
    CreativeAutomationUseCase: At,
    PrintPersonalizationUseCase: Ft,
    StoriesReels: Rt,
    PrintServiceUseCase: Ue,
    Web2PrintUseCase: Tt,
    VideoEditorWebUseCase: We,
    ProductItems: ml,
    IndustryItems: rl,
    UseCaseItems: yl,
    ShowcaseItems: al,
    Careers: Nt,
    TOS: It,
    PrivacyPolicy: Mt,
    ResourcesLinks: ol,
    ResourcesFeaturedData: il,
    PhotoPrintsUseCase: Zt,
    AdTech: Oe,
    EmailMarketing: je,
    ELearning: Wt,
    AIEditor: ct,
    ECommerce: zt,
    CompareItems: cl
  },
  pl = "imgly_305c7",
  ul = {
    "navi-label-is-large": "imgly_57a0e",
    "navi-label-is-small": "imgly_5bc14",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: pl
  },
  O = _ref3 => {
    let {
      className: e,
      children: o,
      ...i
    } = _ref3;
    return /* @__PURE__ */t.createElement("a", {
      ...i,
      className: c(e, ul.root)
    }, o);
  },
  dl = "imgly_215f1",
  hl = "imgly_efe14",
  Q = {
    "navi-label-is-large": "imgly_43327",
    "navi-label-is-small": "imgly_9a6df",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: dl,
    heading: hl
  },
  T = _ref4 => {
    let {
      label: e,
      links: o
    } = _ref4;
    return /* @__PURE__ */t.createElement(D, {
      className: Q.root
    }, /* @__PURE__ */t.createElement("div", {
      className: Q.heading
    }, e), o.map(_ref5 => {
      let {
        name: i,
        url: l,
        analyticsID: a
      } = _ref5;
      return !i || !l ? null : /* @__PURE__ */t.createElement(_, {
        key: i,
        className: Q.wrapper
      }, /* @__PURE__ */t.createElement(O, {
        href: l,
        className: Q.link,
        "data-analytics": a !== null && a !== void 0 ? a : "".concat(a, ", {\"props\": {\"source\": \"/footer\"}}")
      }, i));
    }));
  },
  _l = "imgly_06c91",
  bl = "imgly_5af66",
  Cl = "imgly_82b59",
  vl = "imgly_9f97d",
  El = "imgly_4d1bf",
  fl = "imgly_011e1",
  kl = "imgly_6e300",
  wl = "imgly_157ff",
  xl = "imgly_e4d98",
  Ll = "imgly_cfbc5",
  Sl = "imgly_bf2d6",
  Nl = "imgly_ea49f",
  Il = "imgly_6a52e",
  Ml = "imgly_a8628",
  v = {
    "navi-label-is-large": "imgly_8177d",
    "navi-label-is-small": "imgly_1a4c7",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    footer: _l,
    container: bl,
    grid: Cl,
    column: vl,
    column__is_first: El,
    icon: fl,
    company: kl,
    company__logo: wl,
    legal: xl,
    socials: Ll,
    socials__item: Sl,
    socials__copyright: Nl,
    logo__is_mobile: Il,
    careers: Ml
  },
  Hl = [{
    name: "Instagram",
    analyticsID: F.instagram,
    url: "https://www.instagram.com/img.ly/",
    LogoComponent: we,
    logoAriaLabel: "Visit our Instagram page"
  }, {
    name: "LinkedIn",
    analyticsID: F.linkedIn,
    url: "https://www.linkedin.com/company/img.ly",
    LogoComponent: xe,
    logoAriaLabel: "Visit our LinkedIn page"
  }, {
    name: "Twitter",
    analyticsID: F.twitter,
    url: "https://x.com/imgly",
    LogoComponent: Le,
    logoAriaLabel: "Visit our Twitter page"
  }, {
    name: "GitHub",
    analyticsID: F.github,
    url: "https://github.com/imgly",
    LogoComponent: ke,
    logoAriaLabel: "Visit our GitHub page"
  }],
  O1 = _ref6 => {
    let {
      hiring: e = xt.hiring,
      ...o
    } = _ref6;
    const [i, l] = w(e);
    return x(() => {
      const a = document.getElementById($e);
      a && a.getAttribute("data-hiring") === "true" && l(!0);
    }, [l]), /* @__PURE__ */t.createElement("div", {
      ...o,
      className: c(v.footer, "imgly__on_dark_background")
    }, /* @__PURE__ */t.createElement("div", {
      className: v.container
    }, /* @__PURE__ */t.createElement("div", {
      className: v.grid
    }, /* @__PURE__ */t.createElement("div", {
      className: c(v.column, v.column__is_first)
    }, /* @__PURE__ */t.createElement(D, {
      className: v.company
    }, /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(O, {
      href: m.IMGLY.url,
      "aria-current": "page",
      className: v.company__logo,
      "aria-label": "Go to the main IMGLY page"
    }, /* @__PURE__ */t.createElement(ut, {
      "aria-label": "Go to the main IMGLY page",
      className: v.icon
    }))), m.CompanyItems.map(_ref7 => {
      let {
        name: a,
        url: n
      } = _ref7;
      return /* @__PURE__ */t.createElement(_, {
        key: a
      }, /* @__PURE__ */t.createElement(O, {
        href: n,
        className: c({
          [v.careers]: a === "Careers" && i
        })
      }, a));
    })), /* @__PURE__ */t.createElement(D, {
      className: v.legal
    }, m.LegalItems.map(_ref8 => {
      let {
        name: a,
        url: n
      } = _ref8;
      return /* @__PURE__ */t.createElement(_, {
        key: a
      }, /* @__PURE__ */t.createElement(O, {
        href: n
      }, a));
    })), /* @__PURE__ */t.createElement(D, {
      className: v.socials
    }, Hl.map(_ref9 => {
      let {
        name: a,
        analyticsID: n,
        url: r,
        LogoComponent: g,
        logoAriaLabel: y
      } = _ref9;
      return /* @__PURE__ */t.createElement(_, {
        key: a
      }, /* @__PURE__ */t.createElement(O, {
        href: r,
        target: "_blank",
        className: v.socials__item,
        rel: "noreferrer",
        "data-analytics": "".concat(n, ", {\"props\": {\"source\": \"/footer\"}}")
      }, /* @__PURE__ */t.createElement(g, {
        className: v.icon,
        "aria-label": y
      })));
    }), /* @__PURE__ */t.createElement("div", {
      className: v.socials__copyright
    }, "© 2014 – 2025"))), /* @__PURE__ */t.createElement("div", {
      className: v.column
    }, /* @__PURE__ */t.createElement(O, {
      href: m.IMGLY.url,
      "aria-current": "page",
      className: v.logo__is_mobile,
      "aria-label": "Go to the main Imgly page"
    }, /* @__PURE__ */t.createElement(ut, {
      className: v.icon,
      "aria-label": "Go to the main Imgly page"
    })), /* @__PURE__ */t.createElement(T, {
      label: "Products",
      links: m.ProductItems
    }), /* @__PURE__ */t.createElement(T, {
      label: "Industries",
      links: m.IndustryItems
    }), /* @__PURE__ */t.createElement(T, {
      label: "Compare",
      links: m.CompareItems
    })), /* @__PURE__ */t.createElement("div", {
      className: v.column
    }, /* @__PURE__ */t.createElement(T, {
      label: "Use Cases",
      links: m.UseCaseItems
    }), /* @__PURE__ */t.createElement(T, {
      label: "Showcases",
      links: m.ShowcaseItems
    })), /* @__PURE__ */t.createElement("div", {
      className: v.column
    }, /* @__PURE__ */t.createElement(T, {
      label: "Developers",
      links: m.GuidesDeveloperLinks.cesdk
    }), /* @__PURE__ */t.createElement(T, {
      label: "Resources",
      links: m.ResourceItems
    })))));
  },
  $l = "imgly_87239",
  Dl = {
    "navi-label-is-large": "imgly_993f4",
    "navi-label-is-small": "imgly_f7b1e",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: $l
  },
  Vl = _ref10 => {
    let {
      className: e,
      ...o
    } = _ref10;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement("a", {
      ...o,
      className: c(e, Dl.root, "IMGLY__Header_Careers"),
      href: m.Careers.url
    }, "Remote works! Join us."));
  },
  Pl = "imgly_d5397",
  Al = {
    root: Pl
  },
  Fl = _ref11 => {
    let {
      className: e,
      children: o,
      ...i
    } = _ref11;
    const [l, a] = w(null);
    return x(() => {
      const n = new AbortController();
      return window.addEventListener("resize", () => {
        a(window.innerWidth < 991);
      }, {
        signal: n.signal
      }), l === null && a(window.innerWidth < 991), () => {
        n.abort();
      };
    }, [l, a]), l ? null : /* @__PURE__ */t.createElement(D, {
      ...i,
      className: c(e, Al.root)
    }, o);
  },
  Rl = e => /* @__PURE__ */s.createElement("svg", {
    width: 142,
    height: 30,
    viewBox: "0 0 142 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("title", null, "IMG.LY"), /* @__PURE__ */s.createElement("path", {
    d: "M0.44 29H8.84V0.999998H0.44V29ZM46.5213 0.999998H36.2013L30.2413 19.08L24.3213 0.999998H13.7213V29H21.8013V11.64L27.2013 29H33.3613L38.4413 11.64V29H46.5213V0.999998ZM66.0166 18.96H70.6566C70.2566 21.16 68.4966 22.92 65.3766 22.92C60.7766 22.92 58.5366 19.48 58.5366 15.12C58.5366 11.16 60.3766 7.36 64.8566 7.36C67.7766 7.36 69.3766 9.12 69.6566 10.72H78.8566C78.3366 5.04 73.0566 0.239998 64.9366 0.239998C55.5366 0.239998 50.0566 7.32 50.0566 15C50.0566 23.04 55.3766 29.76 64.9766 29.76C73.2166 29.76 78.0566 25.4 79.0966 18.96H81.7766V13.48H66.0166V18.96ZM105.948 21.88V0.999998H97.6275V29H113.268V21.88H105.948ZM141.93 0.999998H132.65L128.41 10.96L123.89 0.999998H114.13L123.53 19.12L118.69 29H128.05L141.93 0.999998Z",
    fill: "currentColor"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M83.8188 24.68C83.8188 27.32 85.9388 29.48 88.6588 29.48C91.4588 29.48 93.5788 27.32 93.5788 24.68C93.5788 22.04 91.4588 19.88 88.6588 19.88C85.9388 19.88 83.8188 22.04 83.8188 24.68Z",
    fill: "#471AFF"
  })),
  Zl = "imgly_9c223",
  Tl = "imgly_e53d1",
  dt = {
    root: Zl,
    root__is_small: Tl
  },
  Bl = _ref12 => {
    let {
      small: e,
      className: o,
      ...i
    } = _ref12;
    return /* @__PURE__ */t.createElement("a", {
      ...i,
      className: c(o, dt.root, {
        [dt.root__is_small]: e
      }, "IMGLY__header_logo"),
      href: m.IMGLY.url,
      "aria-label": "Go to the main IMGLY page"
    }, /* @__PURE__ */t.createElement(Rl, {
      "aria-label": "IMGLY Logo"
    }));
  },
  Yt = nt({
    smallScreen: !1
  }),
  Gl = "imgly_03e97",
  Kl = "imgly_1b6b5",
  Ul = "imgly_ae84a",
  Ol = "imgly_16000",
  jl = "imgly_caacb",
  Wl = "imgly_efb09",
  zl = "imgly_7dd5e",
  Yl = "imgly_66d12",
  W = {
    "navi-label-is-large": "imgly_0f71c",
    "navi-label-is-small": "imgly_d1b63",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: Gl,
    root__is_icon_button: Kl,
    root__is_small: Ul,
    root__content: Ol,
    root__is_primary: jl,
    root__is_secondary: Wl,
    root__is_tertiary: zl,
    root__is_text: Yl
  };
var f = /* @__PURE__ */(e => (e.Primary = "primary", e.Secondary = "secondary", e.Tertiary = "tertiary", e.Text = "text", e))(f || {});
const ql = (_ref13, p) => {
    let {
      as: e,
      render: o,
      theme: i = f.Primary,
      small: l,
      leadingIcon: a,
      trailingIcon: n,
      className: r,
      children: g,
      ...y
    } = _ref13;
    return /* @__PURE__ */t.createElement(ye, {
      ref: p,
      ...y,
      render: o || e,
      className: c(r, W.root, W["root__is_".concat(i)], {
        [W.root__is_small]: l,
        [W.root__is_icon_button]: !g && (a || n)
      })
    }, /* @__PURE__ */t.createElement(t.Fragment, {
      key: "leadingIcon"
    }, a), g && /* @__PURE__ */t.createElement("span", {
      key: "children",
      className: W.root__content
    }, g), /* @__PURE__ */t.createElement(t.Fragment, {
      key: "trailingIcon"
    }, n));
  },
  M = st(ql),
  Jl = "imgly_cdc8e",
  Ql = "imgly_5ce3e",
  Xl = "imgly_ef45e",
  to = "imgly_20eca",
  eo = "imgly_f0c85",
  lo = "imgly_2f53a",
  oo = "imgly_c6e07",
  io = "imgly_136b8",
  ao = "imgly_8957d",
  no = "imgly_3df22",
  so = "imgly_7bcd5",
  mo = "imgly_af5ff",
  B = {
    "navi-label-is-large": "imgly_42a72",
    "navi-label-is-small": "imgly_2354f",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: Jl,
    popover: Ql,
    container: Xl,
    button: to,
    button__is_icon_button: eo,
    button__is_small: lo,
    button__content: oo,
    button__is_primary: io,
    button__is_secondary: ao,
    button__is_tertiary: no,
    button__is_text: so,
    button__open: mo
  },
  ro = _ref14 => {
    let {
      small: e,
      className: o,
      children: i
    } = _ref14;
    const l = K(null),
      [a, n] = w(null),
      r = mt(),
      g = r.useState("open");
    return x(() => {
      const y = new AbortController(),
        p = new AbortController();
      return window.addEventListener("click", u => {
        l != null && l.current && !l.current.contains(u.target) && g && r.hide();
      }, {
        signal: y.signal
      }), window.addEventListener("blur", u => {
        l != null && l.current && !l.current.contains(u.relatedTarget) && g && r.hide();
      }, {
        signal: p.signal
      }), () => {
        y.abort(), p.abort();
      };
    }, [l, r, g]), x(() => {
      const y = new AbortController();
      return window.addEventListener("imgly-header-menu-close", () => {
        r.hide();
      }, {
        signal: y.signal
      }), () => {
        y.abort();
      };
    }, [r]), x(() => {
      const y = new AbortController();
      return window.addEventListener("resize", () => {
        n(window.innerWidth > 991);
      }, {
        signal: y.signal
      }), a === null && n(window.innerWidth > 991), () => {
        y.abort();
      };
    }, [a, n]), a ? null : /* @__PURE__ */t.createElement("div", {
      ref: l,
      className: c(o, B.root)
    }, /* @__PURE__ */t.createElement(rt, {
      store: r,
      className: c(B.button, B["button__is_".concat(f.Text)], {
        [B.button__open]: g,
        [B.button__is_small]: e
      }, "IMGLY__header_hamburger")
    }), /* @__PURE__ */t.createElement(yt, {
      store: r,
      className: B.popover
    }, /* @__PURE__ */t.createElement(D, {
      className: B.container
    }, /* @__PURE__ */t.createElement(Yt.Provider, {
      value: {
        smallScreen: !a
      }
    }, i))));
  },
  yo = "imgly_a5108",
  co = {
    root: yo
  },
  go = e => {
    const [o, i] = w(null);
    return x(() => {
      const n = new AbortController();
      return window.addEventListener("resize", () => {
        i(window.innerWidth < 991);
      }, {
        signal: n.signal
      }), o === null && i(window.innerWidth < 991), () => {
        n.abort();
      };
    }, [o, i]), {
      handleKeyDown: n => {
        n.key === "Escape" && window && window.dispatchEvent(new CustomEvent("imgly-header-disclosure-close"));
      },
      handleBlur: n => {
        e && e.current && !e.current.contains(n.relatedTarget) && !o && window && window.dispatchEvent(new CustomEvent("imgly-header-disclosure-close"));
      }
    };
  },
  po = _ref15 => {
    let {
      className: e,
      children: o,
      ...i
    } = _ref15;
    const l = K(null),
      {
        handleKeyDown: a,
        handleBlur: n
      } = go(l);
    return /* @__PURE__ */t.createElement("nav", {
      ...i,
      ref: l,
      className: c(e, co.root),
      onKeyDown: a,
      onBlur: n
    }, o);
  },
  qt = _ref16 => {
    let {
      ...e
    } = _ref16;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      ...e,
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.ContactSales.url,
      "data-analytics": "".concat(m.ContactSales.analyticsID, ", {\"props\": {\"source\": \"/nav\"}}")
    }, m.ContactSales.name));
  },
  Jt = _ref17 => {
    let {
      theme: e = f.Text,
      ...o
    } = _ref17;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      ...o,
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.FreeTrial.url,
      theme: e,
      "data-analytics": "".concat(m.FreeTrial.analyticsID, ", {\"props\": {\"source\": \"/nav\"}}")
    }, m.FreeTrial.name));
  },
  Qt = _ref18 => {
    let {
      theme: e = f.Text,
      ...o
    } = _ref18;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      ...o,
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.Pricing.url,
      "data-analytics": "".concat(m.Pricing.analyticsID, ", {\"props\": {\"source\": \"/nav\"}}"),
      theme: e
    }, m.Pricing.name));
  },
  uo = e => /* @__PURE__ */s.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M6.61934 7.0867L0.999785 0.83423C0.710525 0.512392 0.938933 0 1.37166 0L12.6263 0C13.0593 0 13.2876 0.513058 12.9977 0.834741L7.36263 7.08721C7.16386 7.30776 6.81781 7.30752 6.61934 7.0867Z",
    fill: "currentColor"
  })),
  Xt = nt({
    open: !1
  }),
  ho = "imgly_6fa75",
  _o = "imgly_83fbd",
  bo = "imgly_4905b",
  Co = "imgly_d2787",
  vo = "imgly_76f78",
  Eo = "imgly_b19ed",
  fo = "imgly_22a4b",
  ko = "imgly_fed94",
  wo = "imgly_fb9d1",
  xo = "imgly_ad8a1",
  Lo = "imgly_445f5",
  So = "imgly_69e09",
  No = "imgly_93525",
  P = {
    "navi-label-is-large": "imgly_8885d",
    "navi-label-is-small": "imgly_1ba58",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    content: ho,
    container: _o,
    icon: bo,
    icon__is_small: Co,
    button: vo,
    button__is_icon_button: Eo,
    button__is_small: fo,
    button__content: ko,
    button__is_primary: wo,
    button__is_secondary: xo,
    button__is_tertiary: Lo,
    button__is_text: So,
    button__open: No
  },
  tt = _ref19 => {
    let {
      title: e,
      "aria-label": o,
      open: i,
      small: l,
      className: a,
      buttonClassName: n,
      contentClassName: r,
      children: g
    } = _ref19;
    const {
        smallScreen: y
      } = kt(Yt),
      p = mt(),
      u = p.useState("open"),
      b = me(h => {
        var V;
        ((V = h.detail) == null ? void 0 : V.title) !== e && p.hide();
      }, [p, e]),
      E = h => {
        h.preventDefault(), u || (window.dispatchEvent(new CustomEvent("imgly-header-disclosure-close", {
          detail: {
            title: e
          }
        })), p.show());
      },
      C = h => {
        h.preventDefault(), u ? p.hide() : (window.dispatchEvent(new CustomEvent("imgly-header-disclosure-close", {
          detail: {
            title: e
          }
        })), p.show());
      };
    return x(() => {
      const h = new AbortController();
      return window.addEventListener("imgly-header-disclosure-close", b, {
        signal: h.signal
      }), i ? p.show() : !i && typeof i == "boolean" && p.hide(), () => {
        h.abort();
      };
    }, [i, p, b]), /* @__PURE__ */t.createElement("div", {
      className: a,
      onMouseLeave: y ? void 0 : b
    }, /* @__PURE__ */t.createElement(rt, {
      className: c(n, P.button, P["button__is_".concat(f.Text)], {
        [P.button__open]: u,
        [P.button__is_small]: l
      }),
      "aria-label": o,
      store: p,
      onPointerMove: y ? void 0 : E,
      onClick: C
    }, /* @__PURE__ */t.createElement("span", {
      className: P.button__content
    }, e), /* @__PURE__ */t.createElement(uo, {
      className: c(P.icon, {
        [P.icon__is_small]: l
      })
    })), /* @__PURE__ */t.createElement(yt, {
      store: p,
      className: c(r, P.content)
    }, /* @__PURE__ */t.createElement(Xt.Provider, {
      value: {
        open: u
      }
    }, /* @__PURE__ */t.createElement("div", {
      className: P.container
    }, g))));
  },
  Io = "imgly_52c7c",
  Mo = "imgly_101e0",
  ht = {
    "navi-label-is-large": "imgly_aa67c",
    "navi-label-is-small": "imgly_2137c",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: Io,
    root__is_small: Mo
  },
  Ho = _ref20 => {
    let {
      name: e,
      url: o,
      small: i,
      className: l,
      children: a,
      ...n
    } = _ref20;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement("a", {
      ...n,
      className: c(l, ht.root, {
        [ht.root__is_small]: i
      }),
      href: o
    }, e, a));
  },
  $o = "imgly_833fe",
  Do = "imgly_58dd9",
  Vo = "imgly_cf96c",
  Po = "imgly_a70eb",
  Ao = "imgly_7710d",
  Fo = "imgly_d80b0",
  Ro = "imgly_e3b46",
  Zo = "imgly_55f6a",
  To = "imgly_be5cf",
  Bo = "imgly_1c31e",
  Go = "imgly_9203c",
  Ko = "imgly_befc8",
  L = {
    "navi-label-is-large": "imgly_ab6c0",
    "navi-label-is-small": "imgly_5df1b",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    content: $o,
    content__is_small: Do,
    container: Vo,
    column: Po,
    heading: Ao,
    tag: Fo,
    tag__is_pesdk: Ro,
    tag__is_vesdk: Zo,
    tag__is_cesdk: To,
    tag__is_camerasdk: Bo,
    support: Go,
    support__text: Ko
  },
  te = _ref21 => {
    let {
      open: e,
      small: o,
      buttonClassName: i
    } = _ref21;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(tt, {
      buttonClassName: i,
      contentClassName: c(L.content, {
        [L.content__is_small]: o
      }),
      "aria-label": "A menu with different entry points into each SDK documentation",
      title: "Docs",
      open: e,
      small: o
    }, /* @__PURE__ */t.createElement(D, {
      className: L.container
    }, Object.values(m.GuidesDeveloperLinks).map(l => {
      const a = l.map(_ref22 => {
        let {
          name: n,
          url: r
        } = _ref22;
        return r ? /* @__PURE__ */t.createElement(Ho, {
          key: n,
          name: n,
          url: r
        }) : /* @__PURE__ */t.createElement("div", {
          key: n,
          className: c(L.heading, L.tag, {
            [L.tag__is_cesdk]: n.includes("Creative"),
            [L.tag__is_camerasdk]: n.includes("Camera"),
            [L.tag__is_vesdk]: n.includes("Video"),
            [L.tag__is_pesdk]: n.includes("Photo")
          })
        }, n);
      });
      return /* @__PURE__ */t.createElement("div", {
        key: l[0].name,
        className: L.column
      }, a);
    }), /* @__PURE__ */t.createElement("div", {
      className: L.support
    }, /* @__PURE__ */t.createElement("div", {
      className: L.support__text
    }, "Didn't find the answers you were looking for?"), /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.ContactSupport.url
    }, m.ContactSupport.name))))));
  },
  Uo = e => /* @__PURE__ */s.createElement("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4H3.5C2.67157 4 2 4.67157 2 5.5V12.5C2 13.3284 2.67157 14 3.5 14H10.5C11.3284 14 12 13.3284 12 12.5V10H11V12.5C11 12.7761 10.7761 13 10.5 13H3.5C3.22386 13 3 12.7761 3 12.5V5.5C3 5.22386 3.22386 5 3.5 5H6V4Z",
    fill: "currentColor"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9991 2.5V8H12.9991V4.06066L6.52941 10.5303L5.46875 9.46967L11.9384 3H7.99908L7.99908 2H13.4991C13.6317 2 13.7589 2.05268 13.8526 2.14645C13.9464 2.24022 13.9991 2.36739 13.9991 2.5Z",
    fill: "currentColor"
  })),
  ee = e => /* @__PURE__ */s.createElement("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8796 7.82614L8.87963 11.3262L8.12037 10.6754L10.413 8.00058H3.99988V7.00058L10.4127 7.00058L8.12037 4.32618L8.87963 3.67538L11.8796 7.17535C12.0401 7.36259 12.0401 7.6389 11.8796 7.82614Z",
    fill: "currentColor",
    fillOpacity: 0.65
  }));
var q = /* @__PURE__ */(e => (e.PESDK = "pesdk", e.VESDK = "vesdk", e.CESDK = "cesdk", e.CameraSDK = "camerasdk", e))(q || {}),
  at = /* @__PURE__ */(e => (e.PRIVACYSETTINGS = "privacySettings", e))(at || {}),
  k = /* @__PURE__ */(e => (e.ESSENTIAL = "essentialCookies", e.FUNCTIONAL = "functionalCookies", e.PERFORMANCE = "performanceCookies", e.MARKETING = "marketingCookies", e))(k || {});
const Oo = "imgly_5f175",
  jo = "imgly_ed00f",
  Wo = "imgly_34ba5",
  zo = "imgly_edb9a",
  Yo = "imgly_66de5",
  qo = "imgly_41350",
  Jo = "imgly_89fbc",
  Qo = "imgly_0f760",
  Xo = "imgly_e5678",
  ti = "imgly_93972",
  ei = "imgly_df716",
  li = "imgly_e657b",
  oi = "imgly_c14c2",
  ii = "imgly_f4539",
  ai = "imgly_5bf8e",
  ni = "imgly_79c67",
  si = "imgly_e1075",
  mi = "imgly_ec828",
  ri = "imgly_5a500",
  yi = "imgly_49b9d",
  ci = "imgly_59d20",
  gi = "imgly_e751a",
  pi = "imgly_ac6f2",
  ui = "imgly_7022d",
  di = "imgly_d434f",
  S = {
    "navi-label-is-large": "imgly_70bba",
    "navi-label-is-small": "imgly_d00ad",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    overline: Oo,
    overline__text: jo,
    overline__icon: Wo,
    root: zo,
    root__is_pesdk: Yo,
    root__is_vesdk: qo,
    root__is_camerasdk: Jo,
    root__is_cesdk: Qo,
    root__2: Xo,
    root__2__is_pesdk: ti,
    root__2__is_vesdk: ei,
    root__2__is_camerasdk: li,
    name: oi,
    tag: ii,
    tag__is_pesdk: ai,
    tag__is_vesdk: ni,
    tag__is_camerasdk: si,
    tag__is_cesdk: mi,
    description: ri,
    name_2: yi,
    tag_2: ci,
    tag_2__is_pesdk: gi,
    tag_2__is_vesdk: pi,
    tag_2__is_camerasdk: ui,
    tag_2__is_cesdk: di
  },
  J = st((_ref23, y) => {
    let {
      name: e,
      description: o,
      url: i,
      product: l,
      className: a,
      nextrow: n,
      children: r,
      ...g
    } = _ref23;
    return /* @__PURE__ */t.createElement(_, {
      className: a
    }, /* @__PURE__ */t.createElement("a", {
      ...g,
      ref: y,
      className: c(S.root, n ? c(S["root__2__is_".concat(l)], S.root__2) : S["root__is_".concat(l)]),
      href: i
    }, /* @__PURE__ */t.createElement("div", {
      className: S.overline
    }, /* @__PURE__ */t.createElement("div", {
      className: c(S.tag, S["tag__is_".concat(l)])
    }), /* @__PURE__ */t.createElement("div", {
      className: S.overline__text
    }, /* @__PURE__ */t.createElement(ee, {
      className: S.overline__icon
    }))), /* @__PURE__ */t.createElement("div", {
      className: c(n ? S.name_2 : S.name)
    }, e, " "), /* @__PURE__ */t.createElement("span", {
      className: S.description
    }, o), r));
  });
J.displayName = "ProductsItem";
const hi = "imgly_7d1a4",
  _i = "imgly_80bde",
  bi = "imgly_9a49d",
  Ci = "imgly_4d8eb",
  vi = "imgly_1830a",
  Ei = "imgly_70e68",
  fi = "imgly_98222",
  ki = "imgly_4fef3",
  wi = "imgly_01b67",
  xi = "imgly_679e4",
  N = {
    "navi-label-is-large": "imgly_07418",
    "navi-label-is-small": "imgly_b6d60",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    content: hi,
    content__is_small: _i,
    container: bi,
    wrapper: Ci,
    image: vi,
    kits: Ei,
    kits__h4: fi,
    kits__item: ki,
    kits__button: wi,
    kits__icon: xi,
    "container-cesdk": "imgly_01725",
    "container-cesdk__item": "imgly_4fd88"
  },
  le = _ref24 => {
    let {
      open: e,
      small: o,
      buttonClassName: i
    } = _ref24;
    const l = K(null),
      a = K(null);
    return x(() => {
      var r;
      const n = new AbortController();
      if (window.innerWidth > 991) {
        const g = () => {
            a.current && (a.current.style.backgroundImage = "linear-gradient(94.29deg, rgba(173, 0, 255, 0.05), rgba(173, 0, 255, 0.05))");
          },
          y = () => {
            a.current && (a.current.style.backgroundImage = "linear-gradient(94.29deg, rgba(71, 26, 255, 0.06), rgba(71, 26, 255, 0.02))");
          };
        l.current && (l.current.addEventListener("mouseenter", g, {
          signal: n.signal
        }), (r = l.current) == null || r.addEventListener("mouseleave", y, {
          signal: n.signal
        }));
      }
      return () => {
        n.abort();
      };
    }, [l, a]), /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(tt, {
      buttonClassName: i,
      contentClassName: c(N.content, {
        [N.content__is_small]: o
      }),
      "aria-label": "A menu that links to all IMGLY products.",
      title: "Products",
      open: e,
      small: o
    }, /* @__PURE__ */t.createElement(D, {
      className: N.container
    }, /* @__PURE__ */t.createElement("div", {
      ref: a,
      className: N["container-cesdk"]
    }, /* @__PURE__ */t.createElement(J, {
      ref: l,
      className: N["container-cesdk__item"],
      name: m.CESDK.name,
      description: m.CESDK.description,
      url: m.CESDK.url,
      product: q.CESDK,
      nextrow: !1
    }, /* @__PURE__ */t.createElement("img", {
      className: N.image,
      alt: "",
      src: "https://img.ly/static/imgly-website-components/images/navigation-cesdk-content-viz.png",
      loading: "lazy"
    })), /* @__PURE__ */t.createElement("div", {
      className: N.kits
    }, /* @__PURE__ */t.createElement("div", {
      className: N.kits__h4
    }, "Starter Kits"), m.ShowcaseItems.map(_ref25 => {
      let {
        name: n,
        url: r
      } = _ref25;
      return /* @__PURE__ */t.createElement(_, {
        key: n
      }, /* @__PURE__ */t.createElement(M, {
        className: N.kits__item,
        theme: f.Text,
        render: /* @__PURE__ */t.createElement("a", null),
        href: r,
        small: !0,
        trailingIcon: /* @__PURE__ */t.createElement(ee, null)
      }, n));
    }), /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      className: N.kits__button,
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.Showcases.url,
      theme: f.Secondary,
      small: !0,
      trailingIcon: /* @__PURE__ */t.createElement(Uo, {
        className: N.kits__icon
      })
    }, "Explore All Demos")))), /* @__PURE__ */t.createElement("div", {
      className: N.wrapper
    }, /* @__PURE__ */t.createElement(J, {
      name: m.CameraSDK.name,
      description: "",
      url: m.CameraSDK.url,
      product: q.CameraSDK,
      nextrow: !0
    }), /* @__PURE__ */t.createElement(J, {
      name: m.PESDK.name,
      description: "",
      url: m.PESDK.url,
      product: q.PESDK,
      nextrow: !0
    }), /* @__PURE__ */t.createElement(J, {
      name: m.VESDK.name,
      description: "",
      url: m.VESDK.url,
      product: q.VESDK,
      nextrow: !0
    })))));
  },
  Li = "imgly_f07bf",
  Si = {
    root: Li
  },
  Ni = _ref26 => {
    let {
      contentType: e,
      className: o,
      ...i
    } = _ref26;
    return /* @__PURE__ */t.createElement("div", {
      ...i,
      className: c(o, Si.root)
    }, e);
  },
  Ii = "imgly_30342",
  Mi = "imgly_cb6d2",
  Hi = "imgly_24d12",
  $i = "imgly_84861",
  Di = "imgly_a4258",
  Vi = "imgly_f2993",
  A = {
    "navi-label-is-large": "imgly_57033",
    "navi-label-is-small": "imgly_6623c",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    imgHolder: Ii,
    skeletonContainer: Mi,
    image: Hi,
    content: $i,
    heading: Di,
    description: Vi
  },
  Pi = _ref27 => {
    let {
      className: e,
      image: o,
      heading: i,
      description: l,
      contentType: a,
      alt: n,
      ...r
    } = _ref27;
    const g = K(null),
      y = K(null),
      [p, u] = w(!0);
    if (o) {
      const b = new Image();
      b.src = o, b.onload = () => u(!1);
    }
    return x(() => {
      if (g.current && y.current) {
        const b = g.current;
        let E = l || "";
        for (; b.scrollHeight > b.offsetHeight;) {
          const C = E.split(" ").filter(Boolean);
          E = C.slice(0, C.length - 1).join(" "), y.current.textContent = E + " ...";
        }
      }
    }, [l, o]), p ? /* @__PURE__ */t.createElement("div", {
      className: A.skeletonContainer
    }, /* @__PURE__ */t.createElement("div", {
      className: c(A.imgHolder)
    })) : /* @__PURE__ */t.createElement("div", {
      ...r,
      className: e
    }, /* @__PURE__ */t.createElement("div", {
      className: c(A.imgHolder, A.skeleton)
    }, /* @__PURE__ */t.createElement("img", {
      className: A.image,
      alt: n,
      src: o,
      loading: "lazy",
      crossOrigin: "anonymous"
    }), /* @__PURE__ */t.createElement(Ni, {
      contentType: a,
      className: A.pill
    })), /* @__PURE__ */t.createElement("div", {
      ref: g,
      className: A.content
    }, /* @__PURE__ */t.createElement("div", {
      className: A.heading
    }, i), /* @__PURE__ */t.createElement("div", {
      ref: y,
      className: A.description
    }, l)));
  },
  Ai = "imgly_a458e",
  Fi = "imgly_ec05d",
  Ri = "imgly_6fbb9",
  _t = {
    "navi-label-is-large": "imgly_d877c",
    "navi-label-is-small": "imgly_3158e",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    anchor: Ai,
    anchor__is_small: Fi,
    headerItemCard: Ri
  },
  oe = _ref28 => {
    let {
      urlData: e,
      className: o
    } = _ref28;
    const [i, l] = w(null),
      a = K(!0),
      {
        open: n
      } = kt(Xt);
    return x(() => {
      if (!(!n || i)) return fetch(e).then(r => r.json()).then(r => {
        a.current && l(r.posts);
      }).catch(r => console.error("Error:", r)), () => {
        i && (a.current = !1);
      };
    }, [e, n]), i ? /* @__PURE__ */t.createElement(_, {
      className: o
    }, i.slice(0, 4).map(r => /* @__PURE__ */t.createElement("a", {
      key: r.url,
      className: _t.anchor,
      href: r.url
    }, /* @__PURE__ */t.createElement(Pi, {
      image: r.feature_image,
      heading: r.title,
      description: r.excerpt,
      contentType: "Blog",
      className: _t.headerItemCard,
      alt: r.alt
    })))) : null;
  };
oe.displayName = "ResourceItems";
const Zi = "imgly_cd218",
  Ti = "imgly_a2748",
  bt = {
    "navi-label-is-large": "imgly_9320e",
    "navi-label-is-small": "imgly_5c169",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: Zi,
    root__is_small: Ti
  },
  Bi = _ref29 => {
    let {
      name: e,
      url: o,
      small: i,
      className: l,
      children: a,
      ...n
    } = _ref29;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement("a", {
      ...n,
      className: c(l, bt.root, {
        [bt.root__is_small]: i
      }),
      href: o
    }, e, a));
  },
  Gi = "imgly_ef7dd",
  Ki = "imgly_0ef28",
  Ui = "imgly_6848e",
  Oi = "imgly_55d05",
  ji = "imgly_952ce",
  Wi = "imgly_f3372",
  zi = "imgly_2dbf2",
  Yi = "imgly_92128",
  qi = "imgly_42f1f",
  $ = {
    "navi-label-is-large": "imgly_d228f",
    "navi-label-is-small": "imgly_74eac",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    content: Gi,
    content__is_small: Ki,
    container: Ui,
    heading: Oi,
    featured: ji,
    wrapper: Wi,
    container_featured: zi,
    frame: Yi,
    div1: qi
  },
  ie = _ref30 => {
    let {
      open: e,
      small: o,
      buttonClassName: i
    } = _ref30;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(tt, {
      buttonClassName: i,
      contentClassName: c($.content, {
        [$.content__is_small]: o
      }),
      title: "Resources",
      open: e,
      small: o
    }, /* @__PURE__ */t.createElement("div", {
      className: $.wrapper
    }, /* @__PURE__ */t.createElement(D, {
      className: $.container
    }, /* @__PURE__ */t.createElement("div", {
      className: $.column
    }, /* @__PURE__ */t.createElement("div", {
      className: c($.heading)
    }, "Resources"), m.ResourcesLinks.map(_ref31 => {
      let {
        name: l,
        url: a
      } = _ref31;
      return /* @__PURE__ */t.createElement(Bi, {
        key: l,
        name: l,
        url: a
      });
    }))), /* @__PURE__ */t.createElement("div", {
      className: $.container_featured
    }, /* @__PURE__ */t.createElement("div", {
      className: c($.heading, $.featured)
    }, "Featured"), /* @__PURE__ */t.createElement(D, {
      className: $.frame
    }, /* @__PURE__ */t.createElement(oe, {
      className: $.div1,
      urlData: m.ResourcesFeaturedData.url
    }))))));
  },
  j = e => /* @__PURE__ */s.createElement("svg", {
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M8 0.666992V6.66699C8 7.77156 8.89543 8.66699 10 8.66699H16",
    stroke: "#2E2E2F",
    strokeOpacity: 0.35,
    strokeWidth: 1.5
  })),
  Ji = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M17.4998 8C18.3282 8 18.9998 7.32843 18.9998 6.5C18.9998 5.67157 18.3282 5 17.4998 5C16.6713 5 15.9998 5.67157 15.9998 6.5C15.9998 7.32843 16.6713 8 17.4998 8Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9997 2C20.6566 2 21.9997 3.34315 21.9997 5V11.6716C21.9997 12.4672 21.6836 13.2303 21.121 13.7929L13.121 21.7929C11.9494 22.9645 10.05 22.9645 8.87838 21.7929L2.20681 15.1213C1.03523 13.9497 1.03523 12.0503 2.2068 10.8787L10.2068 2.87868C10.7694 2.31607 11.5325 2 12.3281 2H18.9997ZM19.9997 5C19.9997 4.44772 19.552 4 18.9997 4H12.3281C12.0629 4 11.8086 4.10536 11.621 4.29289L3.62102 12.2929C3.23049 12.6834 3.23049 13.3166 3.62102 13.7071L10.2926 20.3787C10.6831 20.7692 11.3163 20.7692 11.7068 20.3787L19.7068 12.3787C19.8943 12.1911 19.9997 11.9368 19.9997 11.6716V5Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M10.7655 8.12631C10.8464 7.90972 11.1528 7.90972 11.2338 8.12631L12.2995 10.9763C12.3346 11.0702 12.4225 11.1341 12.5227 11.1385L15.5625 11.2713C15.7935 11.2814 15.8882 11.5727 15.7072 11.7167L13.326 13.6109C13.2475 13.6733 13.214 13.7767 13.2408 13.8733L14.0538 16.8054C14.1156 17.0282 13.8677 17.2083 13.6749 17.0807L11.1376 15.4014C11.0539 15.346 10.9453 15.346 10.8616 15.4014L8.32434 17.0807C8.13151 17.2083 7.88367 17.0282 7.94545 16.8054L8.75847 13.8733C8.78528 13.7767 8.7517 13.6733 8.6732 13.6109L6.29204 11.7167C6.11108 11.5727 6.20575 11.2814 6.43676 11.2713L9.47654 11.1385C9.57676 11.1341 9.66466 11.0702 9.69979 10.9763L10.7655 8.12631Z",
    fill: "#282F35"
  })),
  Qi = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M20.2066 2.79239C19.2582 1.84398 17.709 1.88268 16.8091 2.87726L8.38583 12.187C7.95689 12.6611 7.97496 13.3883 8.42693 13.8405L9.15794 14.5718C9.61007 15.0242 10.3375 15.0425 10.8118 14.6134L11.5239 13.9691L13.7823 7.92452C14.0744 7.14274 14.8212 6.62451 15.6558 6.62451H17.6401C18.1679 6.62451 18.6606 6.83172 19.0254 7.18183L20.1217 6.18985C21.1163 5.28998 21.155 3.7408 20.2066 2.79239Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93447 20.5551C2.8567 20.5203 2.77925 20.4829 2.70219 20.443C2.28748 20.2279 1.88406 19.9372 1.50374 19.5632C1.42348 19.4843 1.34425 19.4017 1.26615 19.3152C1.15409 19.1912 1.24586 18.9946 1.41101 18.9688C1.5209 18.9517 1.62829 18.927 1.73208 18.8942C2.16739 18.7565 2.53937 18.4744 2.76719 17.9935C2.89361 17.7266 2.97574 17.3982 2.99951 16.9995C3.0994 15.3242 4.34265 13.9995 5.99951 13.9995C7.65636 13.9995 9.16789 15.3512 8.99951 16.9995C8.70428 19.8895 5.63046 21.7613 2.93447 20.5551ZM5.41794 18.7947C6.26755 18.4936 6.91428 17.7319 7.00986 16.7963C7.02263 16.6712 6.98558 16.5043 6.79548 16.3209C6.59339 16.126 6.29498 15.9995 5.99951 15.9995C5.54185 15.9995 5.0416 16.3531 4.99596 17.1185C4.95794 17.7563 4.81455 18.3713 4.53897 18.9237C4.84994 18.9412 5.14734 18.8905 5.41794 18.7947Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M16.9219 10.3516L13.6797 20H11.4062L15.6562 8.625H17.1094L16.9219 10.3516ZM19.6328 20L16.375 10.3516L16.1797 8.625H17.6406L21.9141 20H19.6328ZM19.4844 15.7734V17.4688H13.3828V15.7734H19.4844Z",
    fill: "#282F35"
  })),
  Xi = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M10 18H6.33874L6.1795 17.9857C4.39773 17.8251 3 16.3246 3 14.5C3 12.6379 4.4553 11.1142 6.28921 11.0062L7.77814 10.9185L8.1188 9.46643C8.58515 7.47856 10.3723 6 12.5 6C14.8384 6 16.7602 7.78357 16.9792 10.0645C17.3135 10.0219 17.6542 10 18 10C18.3336 10 18.6625 10.0204 18.9853 10.0601C18.7591 6.67538 15.942 4 12.5 4C9.42297 4 6.84532 6.13808 6.17166 9.00964C3.28695 9.17948 1 11.5727 1 14.5C1 17.369 3.19675 19.725 6 19.9776V20H10.252C10.0875 19.3608 10 18.6906 10 18Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.679 12.0381C19.0561 12.0806 19.3482 12.3718 19.4406 12.7398L19.6729 13.6649C19.8104 14.2125 20.3738 14.5378 20.9168 14.383L21.8336 14.1218C22.198 14.018 22.5957 14.1249 22.8215 14.4293C23.0911 14.7929 23.3206 15.188 23.5034 15.6081C23.6547 15.9556 23.5484 16.3537 23.2762 16.6174L22.5904 17.2819C22.1849 17.6748 22.1849 18.3253 22.5904 18.7182L23.2762 19.3827C23.5484 19.6464 23.6546 20.0444 23.5034 20.392C23.3206 20.8121 23.0911 21.2072 22.8214 21.5708C22.5957 21.8751 22.198 21.9821 21.8335 21.8782L20.9168 21.617C20.3738 21.4623 19.8104 21.7876 19.6729 22.3352L19.4406 23.2602C19.3482 23.6282 19.0561 23.9194 18.6791 23.9619C18.4559 23.9871 18.229 24 17.9991 24C17.7693 24 17.5425 23.9871 17.3195 23.9619C16.9424 23.9194 16.6503 23.6282 16.5579 23.2602L16.3256 22.3352C16.1881 21.7876 15.6247 21.4623 15.0817 21.617L14.1648 21.8783C13.8004 21.9821 13.4027 21.8752 13.1769 21.5708C12.9073 21.2073 12.6778 20.8122 12.495 20.3921C12.3437 20.0446 12.45 19.6465 12.7222 19.3828L13.4081 18.7182C13.8136 18.3253 13.8136 17.6748 13.4081 17.2819L12.7221 16.6173C12.45 16.3535 12.3437 15.9555 12.4949 15.608C12.6777 15.1879 12.9072 14.7928 13.1769 14.4293C13.4026 14.1249 13.8003 14.0179 14.1648 14.1218L15.0817 14.383C15.6247 14.5378 16.1881 14.2125 16.3256 13.6649L16.5579 12.7398C16.6503 12.3718 16.9424 12.0806 17.3195 12.0381C17.5426 12.0129 17.7693 12 17.9991 12C18.229 12 18.4559 12.0129 18.679 12.0381ZM19.4993 18C19.4993 18.8285 18.8278 19.5 17.9993 19.5C17.1709 19.5 16.4993 18.8285 16.4993 18C16.4993 17.1716 17.1709 16.5 17.9993 16.5C18.8278 16.5 19.4993 17.1716 19.4993 18Z",
    fill: "#282F35"
  })),
  ta = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M10.6736 4H5.81564L5.46352 2.73236C5.34329 2.29954 4.94921 2 4.5 2H2C1.44772 2 1 2.44772 1 3C1 3.55228 1.44772 4 2 4H3.73991L5.93348 11.8968L4.82913 14.1057C4.16426 15.4355 5.13125 17 6.618 17H15.9999C16.5522 17 16.9999 16.5523 16.9999 16C16.9999 15.4478 16.5522 15 15.9999 15H6.618L7.61797 13H13.3924C12.5469 12.4905 11.8179 11.8074 11.2547 11H7.76009L6.3712 6H10.0709C10.1719 5.29385 10.3783 4.62171 10.6736 4Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M8 20C8 21.1046 7.10457 22 6 22C4.89543 22 4 21.1046 4 20C4 18.8954 4.89543 18 6 18C7.10457 18 8 18.8954 8 20Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M18 20C18 21.1046 17.1046 22 16 22C14.8954 22 14 21.1046 14 20C14 18.8954 14.8954 18 16 18C17.1046 18 18 18.8954 18 20Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7C23 10.1756 20.4256 12.75 17.25 12.75C14.0744 12.75 11.5 10.1756 11.5 7C11.5 3.82436 14.0744 1.25 17.25 1.25C20.4256 1.25 23 3.82436 23 7ZM19.7314 6.25C19.674 5.09979 19.4855 4.04757 19.1969 3.22115C20.3521 3.81751 21.1987 4.928 21.434 6.25H19.7314ZM18.2294 6.25C18.1732 5.24227 18.0068 4.3616 17.7795 3.71223C17.6373 3.30575 17.4851 3.03027 17.3534 2.87107C17.3078 2.81605 17.2732 2.78432 17.25 2.76645C17.2268 2.78432 17.1922 2.81605 17.1466 2.87107C17.0149 3.03027 16.8627 3.30575 16.7205 3.71223C16.4932 4.3616 16.3268 5.24227 16.2706 6.25H18.2294ZM16.2706 7.75H18.2294C18.1732 8.75773 18.0068 9.6384 17.7795 10.2878C17.6373 10.6942 17.4851 10.9697 17.3534 11.1289C17.3078 11.184 17.2732 11.2157 17.25 11.2336C17.2268 11.2157 17.1922 11.184 17.1466 11.1289C17.0149 10.9697 16.8627 10.6942 16.7205 10.2878C16.4932 9.6384 16.3268 8.75773 16.2706 7.75ZM14.7686 6.25C14.826 5.09979 15.0145 4.04757 15.3031 3.22115C14.1479 3.81751 13.3013 4.928 13.066 6.25H14.7686ZM13.066 7.75H14.7686C14.826 8.90021 15.0145 9.95243 15.3031 10.7788C14.1479 10.1825 13.3013 9.072 13.066 7.75ZM19.7314 7.75H21.434C21.1987 9.072 20.3521 10.1825 19.1969 10.7788C19.4855 9.95243 19.674 8.90021 19.7314 7.75Z",
    fill: "#282F35"
  })),
  ea = e => /* @__PURE__ */s.createElement("svg", {
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M18.0005 13.9289V17.4904C18.0005 18.1303 17.6943 18.7316 17.1768 19.1079L16.794 19.3863C13.6382 21.6815 9.3628 21.6815 6.20694 19.3863L5.82414 19.1079C5.30666 18.7316 5.00049 18.1303 5.00049 17.4904V12.7086L3.50043 11.9191V16.9998C3.50043 17.5521 3.05271 17.9998 2.50043 17.9998C1.94814 17.9998 1.50043 17.5521 1.50043 16.9998L1.50043 10.7022C1.10659 10.1207 1.25809 9.26011 1.95493 8.89335L10.5008 4.39551C10.1875 5.17685 10.0109 6.02782 10.0008 6.91877L4.14743 9.9995L11.5003 13.8695L13.2821 12.9317C14.0247 13.3981 14.861 13.7289 15.7563 13.8895L12.4318 15.6393C11.8487 15.9462 11.1519 15.9462 10.5688 15.6393L7.00049 13.7612V17.4904L7.38329 17.7688C9.83784 19.554 13.1631 19.554 15.6177 17.7688L16.0005 17.4904V13.9289C16.3271 13.9756 16.6609 13.9998 17.0004 13.9998C17.3399 13.9998 17.6738 13.9756 18.0005 13.9289Z",
    fill: "#282F35"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7C23 10.1756 20.4256 12.75 17.25 12.75C14.0744 12.75 11.5 10.1756 11.5 7C11.5 3.82436 14.0744 1.25 17.25 1.25C20.4256 1.25 23 3.82436 23 7ZM19.7314 6.25C19.674 5.09979 19.4855 4.04757 19.1969 3.22115C20.3521 3.81751 21.1987 4.928 21.434 6.25H19.7314ZM18.2294 6.25C18.1732 5.24227 18.0068 4.3616 17.7795 3.71223C17.6373 3.30575 17.4851 3.03027 17.3534 2.87107C17.3078 2.81605 17.2732 2.78432 17.25 2.76645C17.2268 2.78432 17.1922 2.81605 17.1466 2.87107C17.0149 3.03027 16.8627 3.30575 16.7205 3.71223C16.4932 4.3616 16.3268 5.24227 16.2706 6.25H18.2294ZM16.2706 7.75H18.2294C18.1732 8.75773 18.0068 9.6384 17.7795 10.2878C17.6373 10.6942 17.4851 10.9697 17.3534 11.1289C17.3078 11.184 17.2732 11.2157 17.25 11.2336C17.2268 11.2157 17.1922 11.184 17.1466 11.1289C17.0149 10.9697 16.8627 10.6942 16.7205 10.2878C16.4932 9.6384 16.3268 8.75773 16.2706 7.75ZM14.7686 6.25C14.826 5.09979 15.0145 4.04757 15.3031 3.22115C14.1479 3.81751 13.3013 4.928 13.066 6.25H14.7686ZM13.066 7.75H14.7686C14.826 8.90021 15.0145 9.95243 15.3031 10.7788C14.1479 10.1825 13.3013 9.072 13.066 7.75ZM19.7314 7.75H21.434C21.1987 9.072 20.3521 10.1825 19.1969 10.7788C19.4855 9.95243 19.674 8.90021 19.7314 7.75Z",
    fill: "#282F35"
  })),
  la = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4393 4.64645C15.3843 3.7015 17 4.37075 17 5.70711V18.2929C17 19.6292 15.3843 20.2985 14.4393 19.3535L11.3787 16.2928C11.1911 16.1052 10.9368 15.9999 10.6716 15.9999H9V20C9 20.5523 8.55228 21 8 21H6C5.44772 21 5 20.5523 5 20V15.9999H4.5C3.11929 15.9999 2 14.8806 2 13.4999V10.4999C2 9.11917 3.11931 7.99988 4.50004 7.9999L10.6716 7.99999C10.9368 7.99999 11.1912 7.89464 11.3787 7.7071L14.4393 4.64645ZM15 6.91422L12.7929 9.12131C12.2303 9.68393 11.4672 10 10.6715 9.99999L4.50001 9.9999C4.22386 9.9999 4 10.2238 4 10.4999V13.4999C4 13.776 4.22386 13.9999 4.5 13.9999H10.6716C11.4672 13.9999 12.2303 14.316 12.7929 14.8786L15 17.0857V6.91422Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M19 7.96778C20.4817 8.70413 21.5 10.2332 21.5 12C21.5 13.7669 20.4817 15.2959 19 16.0323V7.96778Z",
    fill: "#2E2E2F"
  })),
  oa = e => /* @__PURE__ */s.createElement("svg", {
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M18 12.5C18.5523 12.5 19 12.0523 19 11.5C19 10.9477 18.5523 10.5 18 10.5C17.4477 10.5 17 10.9477 17 11.5C17 12.0523 17.4477 12.5 18 12.5Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8H6V6C6 4.34315 7.34315 3 9 3H15C16.6569 3 18 4.34315 18 6V8H19C20.6569 8 22 9.34315 22 11V15C22 16.1046 21.1046 17 20 17H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V17H4C2.89543 17 2 16.1046 2 15V11C2 9.34315 3.34315 8 5 8ZM16 8H8V6C8 5.44772 8.44772 5 9 5H15C15.5523 5 16 5.44772 16 6V8ZM20 11C20 10.4477 19.5523 10 19 10H5C4.44772 10 4 10.4477 4 11V15H6C6 13.8954 6.89543 13 8 13H16C17.1046 13 18 13.8954 18 15H20V11ZM8 15H16V18C16 18.5523 15.5523 19 15 19H9C8.44772 19 8 18.5523 8 18V15Z",
    fill: "#2E2E2F"
  })),
  ia = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M14.5 2C16.0615 2 17.3842 3.02262 17.8349 4.4347C17.1075 4.20268 16.3288 4.23624 15.6179 4.49982C15.3432 4.19305 14.9442 4 14.5 4H9.5C8.67157 4 8 4.67157 8 5.5V7.43116C7.51947 7.31279 7.01707 7.25 6.5 7.25C6.3317 7.25 6.16495 7.25665 6 7.26971V5.5C6 3.567 7.567 2 9.5 2H14.5Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M6.22759 19.7442C6.72926 21.0629 8.0052 22 9.5 22H14.5C16.433 22 18 20.433 18 18.5V14.4363C17.2859 14.5271 16.5977 14.5448 16 14.502V18.5C16 19.3284 15.3284 20 14.5 20H9.5C9.04139 20 8.63086 19.7942 8.35571 19.4699C7.76942 19.6519 7.14617 19.75 6.5 19.75C6.40873 19.75 6.31791 19.748 6.22759 19.7442Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M10.8373 18H13.5C14.0523 18 14.5 17.5523 14.5 17C14.5 16.4477 14.0523 16 13.5 16H12.2299C11.8994 16.7565 11.4234 17.435 10.8373 18Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4761 4.71847C19.1463 5.1054 19.6295 5.69673 19.8988 6.37933C20.6246 6.27125 21.3783 6.39405 22.0485 6.78097C23.6926 7.73021 24.2114 9.90966 23.2073 11.6489C21.7268 14.2132 17.4122 14.8112 15.2623 14.41C13.8399 12.7487 12.2005 8.71321 13.681 6.14891C14.6851 4.40966 16.832 3.76923 18.4761 4.71847ZM19.0234 12.4537C18.0194 12.7288 16.9921 12.8069 16.2137 12.7621C15.7857 12.1104 15.3397 11.1817 15.0759 10.1747C14.7251 8.83532 14.7891 7.72961 15.1965 7.02391C15.7644 6.04024 16.8732 5.81374 17.6011 6.23402C17.9095 6.41206 18.1383 6.68538 18.2709 7.02156L18.7812 8.31506L20.1566 8.11024C20.514 8.05701 20.8651 8.11848 21.1735 8.29652C21.9014 8.71679 22.2596 9.79024 21.6917 10.7739C21.2843 11.4796 20.3587 12.0878 19.0234 12.4537Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M8.09726 10.2676C8.3734 10.7459 8.20952 11.3575 7.73123 11.6336C7.25294 11.9098 6.64135 11.7459 6.3652 11.2676C6.08906 10.7893 6.25294 10.1777 6.73123 9.90158C7.20952 9.62544 7.82111 9.78931 8.09726 10.2676Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M5.06617 12.0176C5.34231 12.4959 5.17843 13.1075 4.70014 13.3836C4.22185 13.6598 3.61026 13.4959 3.33412 13.0176C3.05797 12.5393 3.22185 11.9277 3.70014 11.6516C4.17843 11.3754 4.79002 11.5393 5.06617 12.0176Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M10.08 14.4591C10.1872 14.059 9.94974 13.6478 9.54964 13.5406C9.14954 13.4334 8.73829 13.6708 8.63108 14.0709C8.41667 14.8711 7.59416 15.346 6.79396 15.1316C6.39386 15.0243 5.98261 15.2618 5.8754 15.6619C5.7682 16.062 6.00564 16.4732 6.40574 16.5804C8.00613 17.0093 9.65114 16.0595 10.08 14.4591Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.978199 16.6872C-0.782208 13.6381 0.262496 9.73917 3.31161 7.97877C6.36073 6.21836 10.2596 7.26306 12.02 10.3122C13.7804 13.3613 12.7357 17.2602 9.68661 19.0206C6.6375 20.781 2.73861 19.7363 0.978199 16.6872ZM4.18661 9.49431C1.97451 10.7715 1.21659 13.6001 2.49374 15.8122C3.7709 18.0243 6.59951 18.7822 8.81161 17.505C11.0237 16.2279 11.7816 13.3993 10.5045 11.1872C9.22732 8.97508 6.39871 8.21715 4.18661 9.49431Z",
    fill: "#2E2E2F"
  })),
  aa = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.34315 2 1 3.34315 1 5V19C1 20.6569 2.34315 22 4 22H20C21.6569 22 23 20.6569 23 19V5C23 3.34315 21.6569 2 20 2H4ZM3 6V19C3 19.5523 3.44772 20 4 20H20C20.5523 20 21 19.5523 21 19V6H3Z",
    fill: "#2E2E2F"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V10C19 10.5523 18.5523 11 18 11H6C5.44772 11 5 10.5523 5 10V9Z",
    fill: "#282F35"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M5 13C5 12.4477 5.44772 12 6 12H9C9.55228 12 10 12.4477 10 13V17C10 17.5523 9.55228 18 9 18H6C5.44772 18 5 17.5523 5 17V13Z",
    fill: "#282F35"
  }), /* @__PURE__ */s.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13C11 12.4477 11.4477 12 12 12H18C18.5523 12 19 12.4477 19 13V17C19 17.5523 18.5523 18 18 18H12C11.4477 18 11 17.5523 11 17V13ZM17.0986 13L15 14.3991L12.9014 13H17.0986ZM18 13.6009L15.9014 15L18 16.3991V13.6009ZM17.0986 17L15 15.6009L12.9014 17H17.0986ZM12 16.3991L14.0986 15L12 13.6009V16.3991Z",
    fill: "#282F35"
  })),
  na = e => /* @__PURE__ */s.createElement("svg", {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M5.35545 2.06745C5.24149 1.72556 4.7579 1.72556 4.64394 2.06745L4.05898 3.82232C4.02166 3.93429 3.9338 4.02215 3.82184 4.05948L2.06694 4.64459C1.72506 4.75858 1.72509 5.24217 2.06699 5.3561L3.82179 5.9409C3.93378 5.97822 4.02166 6.06609 4.05899 6.17808L4.64394 7.93291C4.7579 8.2748 5.24149 8.2748 5.35545 7.93291L5.9404 6.17806C5.97773 6.06608 6.06559 5.97821 6.17757 5.94089L7.93242 5.35594C8.27431 5.24198 8.27431 4.75839 7.93242 4.64442L6.17757 4.05947C6.06559 4.02215 5.97773 3.93428 5.9404 3.8223L5.35545 2.06745Z",
    fill: "#282F35"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M17.9632 3.23614C17.8026 2.80788 17.1968 2.80788 17.0362 3.23614L16.0787 5.78951C16.0285 5.92337 15.9229 6.02899 15.789 6.07918L13.2356 7.0367C12.8074 7.19729 12.8074 7.80307 13.2356 7.96366L15.789 8.92118C15.9229 8.97138 16.0285 9.077 16.0787 9.21085L17.0362 11.7642C17.1968 12.1925 17.8026 12.1925 17.9632 11.7642L18.9207 9.21086C18.9709 9.077 19.0765 8.97138 19.2104 8.92118L21.7637 7.96366C22.192 7.80307 22.192 7.1973 21.7637 7.0367L19.2104 6.07918C19.0765 6.02899 18.9709 5.92337 18.9207 5.78951L17.9632 3.23614Z",
    fill: "#282F35"
  }), /* @__PURE__ */s.createElement("path", {
    d: "M9.30058 7.82012C9.54712 7.1791 10.454 7.1791 10.7006 7.82012L12.3809 12.189C12.4571 12.3871 12.6136 12.5436 12.8117 12.6198L17.1806 14.3001C17.8216 14.5466 17.8216 15.4536 17.1806 15.7001L12.8117 17.3804C12.6136 17.4566 12.4571 17.6131 12.3809 17.8112L10.7006 22.1801C10.454 22.8211 9.54712 22.8211 9.30058 22.1801L7.62024 17.8112C7.54406 17.6131 7.38754 17.4566 7.18947 17.3804L2.82061 15.7001C2.17959 15.4536 2.17959 14.5466 2.82061 14.3001L7.18947 12.6198C7.38754 12.5436 7.54406 12.3871 7.62024 12.189L9.30058 7.82012Z",
    fill: "#282F35"
  })),
  sa = "imgly_c4805",
  ma = "imgly_22ad9",
  ra = "imgly_b0f08",
  lt = {
    "navi-label-is-large": "imgly_c7944",
    "navi-label-is-small": "imgly_ad29e",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: sa,
    image: ma,
    name: ra
  },
  ya = _ref32 => {
    let {
      name: e,
      url: o,
      image: i,
      className: l,
      ...a
    } = _ref32;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement("a", {
      ...a,
      className: c(l, lt.root),
      href: o
    }, /* @__PURE__ */t.createElement(i, {
      className: lt.image
    }), /* @__PURE__ */t.createElement("div", {
      className: lt.name
    }, e, " ")));
  },
  ca = "imgly_9f70f",
  ga = "imgly_e490f",
  pa = "imgly_d85b0",
  ot = {
    "navi-label-is-large": "imgly_bbbc6",
    "navi-label-is-small": "imgly_4d565",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: ca,
    name: ga,
    image: pa
  },
  ua = _ref33 => {
    let {
      name: e,
      url: o,
      image: i,
      className: l,
      ...a
    } = _ref33;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement("a", {
      ...a,
      className: c(l, ot.root),
      href: o
    }, /* @__PURE__ */t.createElement(i, {
      className: ot.image
    }), /* @__PURE__ */t.createElement("div", {
      className: ot.name
    }, e, " ")));
  },
  da = "imgly_3414c",
  ha = "imgly_ee189",
  _a = "imgly_862cb",
  ba = "imgly_4a2c2",
  Ca = "imgly_a62fc",
  va = "imgly_602b0",
  Ea = "imgly_38d1a",
  R = {
    "navi-label-is-large": "imgly_2cf7f",
    "navi-label-is-small": "imgly_dcd14",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    content: da,
    content__is_small: ha,
    wrapper: _a,
    row: ba,
    note: Ca,
    note__text: va,
    note__link: Ea
  },
  fa = [{
    name: m.PrintIndustry.name,
    url: m.PrintIndustry.url,
    icon: oa
  }, {
    name: m.PhotoPrintsUseCase.name,
    url: m.PhotoPrintsUseCase.url,
    icon: j
  }, {
    name: m.PrintPersonalizationUseCase.name,
    url: m.PrintPersonalizationUseCase.url,
    icon: j
  }, {
    name: m.VariableDataPrintingUseCase.name,
    url: m.VariableDataPrintingUseCase.url,
    icon: j
  }, {
    name: m.Web2PrintUseCase.name,
    url: m.Web2PrintUseCase.url,
    icon: j
  }, {
    name: m.SocialMediaIndustry.name,
    url: m.SocialMediaIndustry.url,
    icon: ia
  }, {
    name: m.StoriesReels.name,
    url: m.StoriesReels.url,
    icon: j
  }, {
    name: m.MarketingTechIndustry.name,
    url: m.MarketingTechIndustry.url,
    icon: la
  }, {
    name: m.CreativeAutomationUseCase.name,
    url: m.CreativeAutomationUseCase.url,
    icon: Qi
  }, {
    name: m.DAMIndustry.name,
    url: m.DAMIndustry.url,
    icon: Xi
  }, {
    name: m.AIEditor.name,
    url: m.AIEditor.url,
    icon: na
  }, {
    name: m.ELearning.name,
    url: m.ELearning.url,
    icon: ea
  }, {
    name: m.BrandAgenciesIndustry.name,
    url: m.BrandAgenciesIndustry.url,
    icon: Ji
  }, {
    name: m.ECommerce.name,
    url: m.ECommerce.url,
    icon: ta
  }, {
    name: m.WebsiteBuilderIndustry.name,
    url: m.WebsiteBuilderIndustry.url,
    icon: aa
  }],
  ae = _ref34 => {
    let {
      open: e,
      small: o,
      buttonClassName: i
    } = _ref34;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(tt, {
      buttonClassName: i,
      contentClassName: c(R.content, {
        [R.content__is_small]: o
      }),
      "aria-label": "A menu that links to different use cases for the CE.SDK",
      title: "Solutions",
      open: e,
      small: o
    }, /* @__PURE__ */t.createElement(D, {
      className: R.container
    }, /* @__PURE__ */t.createElement("div", {
      className: R.wrapper
    }, /* @__PURE__ */t.createElement("div", {
      className: R.row
    }, fa.map(l => l.icon != j ? /* @__PURE__ */t.createElement(ya, {
      key: l.name,
      name: l.name,
      url: l.url,
      image: l.icon
    }) : /* @__PURE__ */t.createElement(ua, {
      key: l.name,
      name: l.name,
      url: l.url,
      image: l.icon
    })))), /* @__PURE__ */t.createElement("div", {
      className: R.note
    }, /* @__PURE__ */t.createElement("span", {
      className: R.note__text
    }, "Can‘t find what you‘re looking for?", /* @__PURE__ */t.createElement("br", null), /* @__PURE__ */t.createElement("a", {
      className: R.note__link,
      href: m.ContactSales.url
    }, "Talk to us"), " ", "to find the right solution for your use case.")))));
  },
  ka = "imgly_c460b",
  wa = "imgly_f0008",
  Ct = {
    buttons: ka,
    menu: wa
  },
  xa = _ref35 => {
    let {
      small: e
    } = _ref35;
    return /* @__PURE__ */t.createElement(t.Fragment, null, /* @__PURE__ */t.createElement("div", {
      className: Ct.menu
    }, /* @__PURE__ */t.createElement(le, {
      buttonClassName: "IMGLY__Header_Item",
      small: e
    }), /* @__PURE__ */t.createElement(ae, {
      buttonClassName: "IMGLY__Header_Item",
      small: e
    }), /* @__PURE__ */t.createElement(te, {
      buttonClassName: "IMGLY__Header_Item",
      small: e
    }), /* @__PURE__ */t.createElement(Qt, {
      className: "IMGLY__Header_Item",
      small: e
    }), /* @__PURE__ */t.createElement(ie, {
      buttonClassName: "IMGLY__Header_Item",
      small: e
    })), /* @__PURE__ */t.createElement("div", {
      className: Ct.buttons
    }, /* @__PURE__ */t.createElement(qt, {
      className: "IMGLY__Header_Item",
      small: e
    }), /* @__PURE__ */t.createElement(Jt, {
      className: "IMGLY__Header_Item",
      small: e
    })));
  },
  La = "imgly_24567",
  Sa = "imgly_eba32",
  Na = "imgly_9a9b7",
  Ia = "imgly_3905b",
  z = {
    buttons: La,
    buttons__button: Sa,
    menu: Na,
    menu__item: Ia
  },
  Ma = () => /* @__PURE__ */t.createElement(t.Fragment, null, /* @__PURE__ */t.createElement("div", {
    className: z.menu
  }, /* @__PURE__ */t.createElement(le, null), /* @__PURE__ */t.createElement(ae, null), /* @__PURE__ */t.createElement(te, null), /* @__PURE__ */t.createElement(Qt, {
    className: z.menu__item
  }), /* @__PURE__ */t.createElement(ie, null)), /* @__PURE__ */t.createElement("div", {
    className: z.buttons
  }, /* @__PURE__ */t.createElement(qt, {
    className: z.buttons__button
  }), /* @__PURE__ */t.createElement(Jt, {
    className: z.buttons__button,
    theme: f.Secondary
  }))),
  j1 = _ref36 => {
    let {
      small: e,
      hiring: o = xt.hiring,
      className: i,
      ...l
    } = _ref36;
    const [a, n] = w(o);
    return x(() => {
      const r = document.getElementById(He);
      r && r.getAttribute("data-hiring") === "true" && n(!0);
    }, [n]), /* @__PURE__ */t.createElement(po, {
      ...l,
      className: i
    }, /* @__PURE__ */t.createElement(Bl, {
      small: e
    }), /* @__PURE__ */t.createElement(Fl, null, /* @__PURE__ */t.createElement(xa, {
      small: e
    })), a && /* @__PURE__ */t.createElement(Vl, null), /* @__PURE__ */t.createElement(ro, {
      small: e
    }, /* @__PURE__ */t.createElement(Ma, null)));
  },
  Ha = nt({
    trackFunctional: !1,
    trackPerformance: !1,
    trackMarketing: !1
  }),
  vt = e => {
    const o = document.cookie.match("(^|;) ?".concat(e, "=([^;]*)(;|$)"));
    return o ? o[2] : null;
  },
  gt = (e, o) => {
    const i = document.createElement("script");
    i.type = "text/javascript", o && (typeof o == "string" ? o.split(" ").forEach(a => {
      if (a.includes("=")) {
        const [n, r] = a.split("=");
        i.setAttribute(n, r);
      } else i.setAttribute(a, "");
    }) : typeof o == "object" && Object.entries(o).forEach(_ref37 => {
      let [a, n] = _ref37;
      i.setAttribute(a, n.toString());
    })), i.src = e;
    const l = document.getElementsByTagName("script")[0];
    l != null && l.parentNode ? l.parentNode.insertBefore(i, l) : document.getElementsByTagName("head")[0].appendChild(i);
  },
  $a = "GTM-PM8MPDG",
  Da = () => {
    window.dataLayer = window.dataLayer || [], window.dataLayer.push({
      "gtm.start": /* @__PURE__ */new Date().getTime(),
      event: "gtm.js"
    }), gt("https://www.googletagmanager.com/gtm.js?id=".concat($a), "async");
  },
  Va = "2498814",
  Pa = () => {
    gt("//js.hs-scripts.com/".concat(Va, ".js"), {
      id: "hs-script-loader",
      async: !0,
      defer: !0
    });
  },
  Aa = e => {
    const o = new AbortController();
    gt("https://img.ly/plaus-proxy/js/script.js", {
      key: "analytics",
      defer: !0,
      "data-domain": "img.ly",
      "data-api": "https://img.ly/plaus-proxy/api/event"
    }), window.plausible = window.plausible || function () {
      for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
        a[_key] = arguments[_key];
      }
      (window.plausible.q = window.plausible.q || []).push(a);
    };
    const i = a => {
      const n = a.type === "auxclick",
        r = a.type === "click";
      if (n || r) {
        const g = a.target.getAttribute("data-analytics");
        if (g) {
          let y = null;
          if (g.includes(",")) {
            const [p, u] = g.split(",");
            if (u.includes("props")) try {
              JSON.parse(u), y = [p, JSON.parse(u)];
            } catch {
              y = [p, e || {}];
            } else y = [p, e || {}];
          } else y = [g, e || {}];
          y && plausible(...y);
        }
      }
    };
    return document.querySelectorAll("[data-analytics]").forEach(a => {
      a.addEventListener("click", i, {
        signal: o.signal
      }), a.addEventListener("auxclick", i, {
        signal: o.signal
      });
    }), o;
  },
  Et = ["blogcatalog", "cotweet", "delicious", "digg", "facebook", "fb", "fark", "flickr", "friendfeed", "hackernews", "hootsuite", "instagram", "ig", "knol", "linkedin", "livejournal", "meebo", "metacafe", "mixx", "mybloglog", "myspace", "ning", "orkut", "pinterest", "plurk", "propeller", "quora", "reddit", "seesmic", "slashdot", "slide", "slideshare", "snapchat", "sphinn", "stumbleupon", "squidoo", "technorati", "tipd", "triiibes", "tumblr", "twitch", "twitter", "vimeo", "whatsapp", "x", "xing", "youtube"],
  ft = ["ameblo.jp", "badoo.com", "blogspot.com", "digg.com", "diigo.com", "dzone.com", "facebook.com", "facebook", "getpocket.com", "groups.google.com", "hatena.ne.jp", "instagram.com", "instapaper.com", "linkedin.com", "linkedin", "lnkd.in", "meetup.com", "myspace.com", "naver.com", "netvibes.com", "pinboard.in", "pinterest.com", "plurk.com", "plus.google.com", "quora.com", "reddit.com", "scoop.it", "slideshare.net", "stackoverflow.com", "stumbleupon.com", "t.co", "twitter.com", "twitter", "vimeo.com", "vk.com", "weibo.cn", "weibo.com", "xing.com", "x.com", "yammer.com", "ycombinator.com", "youtube.com"],
  Fa = ["360.cn", "alice.com", "aliceadsl.fr", "alicesuche.aol.de", "alltheweb.com", "altavista.com", "aol.com", "ask.com", "baidu.com", "biglobe.ne.jp", "bing.com", "buscador.terra.com.br", "cnn.com/SEARCH", "daum.net", "duckduckgo.com", "ecosia.org", "ekolay.net", "eniro.se", "globo.com/busca", "go.mail.ru", "goo.ne.jp", "google", "haosou.com/s", "isearch.avg.com", "kvasir.no", "local.msn.com", "lycos.com", "m.yahoo.com", "mamma.com", "money.msn.com", "msn.com", "mynet.com", "najdi.si", "naver.com", "ozu.es", "qwant.com", "rakuten.co.jp", "rambler.ru", "search-results.com", "search.aol.fr", "search.auone.jp", "search.babylon.com", "search.centrum.cz", "search.comcast.net", "search.conduit.com", "search.incredimail.com", "search.lycos.de", "search.netscape.com", "search.smt.docomo.ne.jp", "search.tut.by", "search.ukr.net", "search.virgilio.it", "sesam.no", "seznam.cz", "so.com/s", "sogou.com", "startsiden.no/sok", "szukacz.pl", "szukaj.onet.pl", "voila.fr", "wp.pl", "yahoo.cn", "yahoo.com", "yam.com", "yandex.com", "yandex.ru"],
  Ra = _ref38 => {
    let {
      searchParams: e,
      referer: o
    } = _ref38;
    const {
        utm_medium: i,
        utm_source: l,
        utm_campaign: a,
        source: n
      } = e,
      r = /cpc|ppc|paidsearch|paid_search/.test(i),
      g = /paidsocial/.test(i) || /paidsocial/.test(l),
      y = /email/.test(i),
      p = /display|cpm|banner/.test(i),
      u = /marketplace/.test(i),
      b = Et.includes(l) || ft.some(C => o.includes(C)),
      E = Fa.some(C => o.includes(C));
    return g || r && (Et.includes(l) || ft.some(C => o.includes(C))) ? "paid_social" : r ? "paid_search" : y ? "email" : p ? "display" : b ? "organic_social" : u ? "marketplace" : E ? "organic" : i || l || a || n ? "other" : o && o.length ? "referer" : "direct";
  },
  Za = _ref39 => {
    let {
      search: e,
      referer: o,
      pageUrl: i
    } = _ref39;
    const l = Object.fromEntries(new URLSearchParams(e));
    return {
      refererChannel: Ra({
        searchParams: l,
        referer: o
      }),
      pageUrl: i,
      refererUrl: o,
      utmCampaignId: l.utm_id,
      utmCampaignSource: l.utm_source,
      utmCampaignMedium: l.utm_medium,
      utmCampaignName: l.utm_campaign,
      utmCampaignTerm: l.utm_term || l.utm_keyword,
      utmCampaignContent: l.utm_content,
      firstVisitDate: /* @__PURE__ */new Date().toISOString()
    };
  },
  Ta = e => {
    const o = Za(e);
    if (o) {
      const i = /* @__PURE__ */new Date();
      i.setFullYear(i.getFullYear() + 5), document.cookie.includes("initialVisitData") || (document.cookie = "initialVisitData=".concat(JSON.stringify(o), ";expires=").concat(i.toUTCString(), ";path=/;"));
    }
  },
  Ba = "imgly_096f3",
  Ga = {
    root: Ba
  },
  ne = st((e, o) => /* @__PURE__ */t.createElement("div", {
    ...e,
    className: Ga.root,
    ref: o
  }));
ne.displayName = "CookieBannerBackdrop";
const Ka = _ref40 => {
    let {
      onClick: e
    } = _ref40;
    return /* @__PURE__ */t.createElement(M, {
      theme: f.Secondary,
      onClick: e
    }, "Reject all cookies");
  },
  Ua = _ref41 => {
    let {
      onClick: e
    } = _ref41;
    return /* @__PURE__ */t.createElement(M, {
      theme: f.Secondary,
      onClick: e
    }, "Save Current Selections");
  },
  Oa = e => /* @__PURE__ */s.createElement("svg", {
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M12.25 6.25L7 1L1.75 6.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })),
  ja = "imgly_a966b",
  Wa = "imgly_9b831",
  za = "imgly_fd574",
  Ya = "imgly_c108d",
  qa = "imgly_d0ebf",
  Y = {
    checkbox: ja,
    checkbox__is_disabled: Wa,
    slider: za,
    slider__is_disabled: Ya,
    input: qa
  },
  Ja = _ref42 => {
    let {
      onChange: e,
      name: o,
      checked: i,
      disabled: l,
      className: a
    } = _ref42;
    return /* @__PURE__ */t.createElement("label", {
      htmlFor: o,
      className: c(a, Y.checkbox, {
        [Y.checkbox__is_disabled]: l
      })
    }, /* @__PURE__ */t.createElement(ce, {
      id: o,
      name: o,
      className: Y.input,
      checked: i,
      disabled: l,
      onChange: e
    }), /* @__PURE__ */t.createElement("span", {
      className: c(Y.slider, {
        [Y.slider__is_disabled]: l
      })
    }));
  },
  Qa = "imgly_423af",
  Xa = "imgly_ab407",
  t1 = "imgly_dfe5a",
  e1 = "imgly_d79b9",
  l1 = "imgly_982ae",
  o1 = "imgly_5a693",
  i1 = "imgly_dbc4b",
  G = {
    "navi-label-is-large": "imgly_72280",
    "navi-label-is-small": "imgly_19516",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: Qa,
    root__is_active: Xa,
    button: t1,
    label: e1,
    text: l1,
    icon: o1,
    icon__is_rotated: i1
  },
  X = _ref43 => {
    let {
      name: e,
      label: o,
      disabled: i,
      checked: l,
      onChange: a,
      children: n
    } = _ref43;
    const r = mt(),
      g = r.useState("open");
    return /* @__PURE__ */t.createElement("div", {
      className: c(G.root, {
        [G.root__is_active]: l
      })
    }, /* @__PURE__ */t.createElement(rt, {
      className: G.button,
      store: r
    }, /* @__PURE__ */t.createElement("div", {
      className: G.label
    }, o), /* @__PURE__ */t.createElement(Oa, {
      className: c(G.icon, {
        [G.icon__is_rotated]: g
      })
    })), /* @__PURE__ */t.createElement(Ja, {
      onChange: a,
      name: e,
      checked: l,
      disabled: i
    }), /* @__PURE__ */t.createElement(yt, {
      store: r,
      className: G.text
    }, n));
  },
  a1 = "imgly_e78e6",
  n1 = {
    root: a1
  },
  s1 = _ref44 => {
    let {
      onChange: e,
      functionalCookie: o,
      performanceCookie: i,
      marketingCookie: l
    } = _ref44;
    return /* @__PURE__ */t.createElement("div", {
      className: n1.root
    }, /* @__PURE__ */t.createElement(X, {
      name: "essential_cookies",
      label: "Essential Cookies",
      onChange: e,
      disabled: !0,
      checked: !0
    }, "..are necessary for you to browse our website and use its features, such as accessing secure areas of the site. These cookies are first-party session cookies, and do not provide any information that would make you identifiable."), /* @__PURE__ */t.createElement(X, {
      name: "functional_cookies",
      label: "Functional Cookies",
      onChange: e,
      checked: o
    }, "..allow our website to remember choices you have made in the past, like what language you prefer, or what your user name is so you can log in more easily. Generally speaking, they enable us to provide you with a more convenient experience of our website."), /* @__PURE__ */t.createElement(X, {
      name: "performance_cookies",
      label: "Performance Cookies",
      onChange: e,
      checked: i
    }, "..collect information about how you use our website, like which pages you visited and which links you clicked on. These cookies are all aggregated and, therefore, anonymized. None of this information can be used to identify you. It is their sole purpose to improve website functions. This includes cookies from third-party analytics services which are for our exclusive use."), /* @__PURE__ */t.createElement(X, {
      name: "marketing_cookies",
      label: "Marketing Cookies",
      onChange: e,
      checked: l
    }, "..track your online activity and make you identifiable to us. They help us deliver more relevant content to you and therefore improve your user journey. These cookies can share that information with other organizations or advertisers."));
  },
  m1 = _ref45 => {
    let {
      onClick: e
    } = _ref45;
    return /* @__PURE__ */t.createElement(M, {
      theme: f.Secondary,
      onClick: e
    }, "Manage separately");
  },
  r1 = "imgly_6a39f",
  y1 = "imgly_e263a",
  c1 = "imgly_a71fe",
  g1 = "imgly_ba482",
  p1 = "imgly_79a72",
  u1 = "imgly_f2a8f",
  Z = {
    "navi-label-is-large": "imgly_94e6b",
    "navi-label-is-small": "imgly_f15ff",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    dialog: r1,
    container: y1,
    h3: c1,
    text: g1,
    text__link: p1,
    buttons: u1
  },
  d1 = _ref46 => {
    let {
      open: e,
      setCookie: o
    } = _ref46;
    const i = ge({
        animated: !0
      }),
      l = i.useState("open"),
      [a, n] = w("start"),
      [r, g] = w(!1),
      [y, p] = w(!1),
      [u, b] = w(!1);
    x(() => {
      !l && e ? i.show() : l && !e && i.hide();
    }, [e, i]);
    const E = () => {
        n("settings");
      },
      C = () => {
        o("".concat(k.ESSENTIAL, "|").concat(k.FUNCTIONAL, "|").concat(k.PERFORMANCE, "|").concat(k.MARKETING));
      },
      h = () => {
        let H = k.ESSENTIAL;
        r && (H += "|".concat(k.FUNCTIONAL)), y && (H += "|".concat(k.PERFORMANCE)), u && (H += "|".concat(k.MARKETING)), o(H);
      },
      V = () => {
        o(k.ESSENTIAL);
      },
      et = H => {
        const d = H.target.name;
        d === "functional_cookies" ? g(H.target.checked) : d === "performance_cookies" ? p(H.target.checked) : d === "marketing_cookies" && b(H.target.checked);
      };
    return /* @__PURE__ */t.createElement(pe, {
      className: Z.dialog,
      store: i,
      "aria-label": "Cookie Consent",
      backdrop: ne,
      autoFocusOnShow: !1
    }, /* @__PURE__ */t.createElement("div", {
      className: Z.container
    }, /* @__PURE__ */t.createElement("div", {
      className: Z.h3
    }, "We Would Love To Use Cookies"), /* @__PURE__ */t.createElement("p", {
      className: Z.text
    }, "Help us improve our Website. We use cookies to provide you with a user-friendly website and for marketing."), /* @__PURE__ */t.createElement("p", {
      className: Z.text
    }, "By clicking accept you agree to the terms of our", " ", /* @__PURE__ */t.createElement("a", {
      className: Z.text__link,
      href: m.PrivacyPolicy.url,
      target: "_blank",
      rel: "noreferrer"
    }, "privacy policy"), " ", "and our", " ", /* @__PURE__ */t.createElement("a", {
      className: Z.text__link,
      href: m.TOS.url,
      target: "_blank",
      rel: "noreferrer"
    }, "terms of services"), ", and help us improve our web presence."), a === "settings" && /* @__PURE__ */t.createElement(s1, {
      onChange: et,
      functionalCookie: r,
      performanceCookie: y,
      marketingCookie: u
    }), /* @__PURE__ */t.createElement("div", {
      className: Z.buttons
    }, a === "start" ? /* @__PURE__ */t.createElement(t.Fragment, null, /* @__PURE__ */t.createElement(m1, {
      onClick: E
    }), /* @__PURE__ */t.createElement(Ka, {
      onClick: V
    })) : /* @__PURE__ */t.createElement(Ua, {
      onClick: h
    }), /* @__PURE__ */t.createElement(M, {
      theme: f.Secondary,
      onClick: C
    }, "Accept all cookies"))));
  },
  W1 = _ref47 => {
    let {
      plausibleSettings: e,
      hubspot: o = !0,
      googleTagManager: i = !0,
      plausible: l = !0,
      saveCookie: a = !0,
      children: n,
      ...r
    } = _ref47;
    const [g, y] = w(!1),
      [p, u] = w(!1),
      [b, E] = w(!1),
      [C, h] = w(!1),
      V = () => {
        const d = vt(at.PRIVACYSETTINGS);
        d != null && d.includes(k.MARKETING) && u(!0), d != null && d.includes(k.FUNCTIONAL) && E(!0), d != null && d.includes(k.PERFORMANCE) && h(!0), d != null && d.includes(k.MARKETING) && (u(!0), o && Pa(), i && Da());
      },
      et = d => {
        const pt = "privacySettings=".concat(d, ";max-age=31536000;SameSite=Lax;path=/;");
        a ? document.cookie = pt : console.log("cookie", pt), d.includes(k.MARKETING) && u(!0), d.includes(k.PERFORMANCE) && h(!0), d.includes(k.FUNCTIONAL) && E(!0), y(!1), V();
      };
    x(() => {
      Ta({
        search: window.location.search.toLowerCase(),
        referer: document.referrer,
        pageUrl: window.location.href
      });
      let d = null;
      return l && (d = Aa(e)), vt(at.PRIVACYSETTINGS) === null ? y(!0) : V(), () => {
        d && d.abort();
      };
    }, []);
    const H = re(() => ({
      trackFunctional: b,
      trackMarketing: p,
      trackPerformance: C
    }), [b, p, C]);
    return /* @__PURE__ */t.createElement(Ha.Provider, {
      value: H
    }, /* @__PURE__ */t.createElement(d1, {
      ...r,
      open: g,
      setCookie: et
    }), n);
  },
  h1 = e => /* @__PURE__ */s.createElement("svg", {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }, /* @__PURE__ */s.createElement("path", {
    d: "M7.62244 10.5867L4.24978 6.83423C3.96052 6.51239 4.18893 6 4.62166 6L11.3763 6C11.8093 6 12.0376 6.51306 11.7477 6.83474L8.36573 10.5872C8.16696 10.8078 7.82091 10.8076 7.62244 10.5867Z",
    fill: "currentColor",
    fillOpacity: 0.9
  })),
  _1 = "imgly_a2e7b",
  b1 = "imgly_c09f5",
  C1 = "imgly_114ad",
  v1 = "imgly_fef4b",
  E1 = "imgly_357fe",
  f1 = "imgly_842b6",
  U = {
    "navi-label-is-large": "imgly_750fb",
    "navi-label-is-small": "imgly_7a5be",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    selectItemCheckbox: _1,
    selectItem: b1,
    selectItem__checked: C1,
    selectItem__multi: v1,
    selectItem__single: E1,
    selectItemLabelWrapper: f1
  },
  k1 = _ref48 => {
    let {
      option: e,
      multi: o,
      value: i
    } = _ref48;
    const l = o ? "multi" : "single",
      a = i instanceof Array ? i.includes(e.value) : i === e.value;
    return /* @__PURE__ */t.createElement(ue, {
      key: e.value,
      focusOnHover: !1,
      value: e.value,
      className: c(U.selectItem, U["selectItem__".concat(l)], {
        [U.selectItem__checked]: a
      })
    }, /* @__PURE__ */t.createElement("div", {
      className: U.selectItemLabelWrapper
    }, /* @__PURE__ */t.createElement("span", {
      className: c(U.selectItemCheckbox, U["selectItemCheckbox__".concat(l)])
    }), /* @__PURE__ */t.createElement("span", null, e.label)), e.labelRight && /* @__PURE__ */t.createElement("span", null, e.labelRight));
  },
  w1 = "imgly_973cd",
  x1 = "imgly_d4f2d",
  L1 = "imgly_4cb6f",
  it = {
    popover: w1,
    select: x1,
    button__active: L1
  },
  z1 = _ref49 => {
    let {
      label: e,
      options: o,
      value: i,
      disabled: l,
      small: a = !0,
      className: n,
      selectClassName: r,
      popoverClassName: g,
      onChange: y
    } = _ref49;
    const p = de({
        value: i,
        // @ts-ignore
        setValue: y
      }),
      u = p.useState("value"),
      b = p.useState("mounted"),
      E = Array.isArray(u),
      C = u.length > 0;
    return /* @__PURE__ */t.createElement("div", {
      className: n
    }, /* @__PURE__ */t.createElement(he, {
      as: M,
      theme: f.Secondary,
      small: a,
      trailingIcon: /* @__PURE__ */t.createElement(h1, null),
      store: p,
      className: c(r, it.select, {
        [it.button__active]: C && E
      }),
      disabled: l
    }, e, E && u.length > 0 ? " (".concat(u.length.toString(), ")") : ""), b && /* @__PURE__ */t.createElement(_e, {
      store: p,
      className: c(g, it.popover),
      gutter: 8
    }, o.map(h =>
    // @ts-ignore
    /* @__PURE__ */
    t.createElement(k1, {
      key: h.value,
      multi: E,
      value: u,
      option: h
    }))));
  },
  S1 = "imgly_4bc01",
  N1 = "imgly_b2257",
  I1 = "imgly_16bda",
  M1 = "imgly_2aa1b",
  H1 = "imgly_e9319",
  $1 = "imgly_f480a",
  D1 = "imgly_17d11",
  V1 = "imgly_a1df5",
  P1 = "imgly_2b329",
  A1 = "imgly_ef132",
  F1 = "imgly_21946",
  R1 = "imgly_913b7",
  Z1 = "imgly_55eff",
  T1 = "imgly_8a702",
  B1 = "imgly_b9701",
  G1 = "imgly_5a32d",
  I = {
    "navi-label-is-large": "imgly_d1343",
    "navi-label-is-small": "imgly_bbe06",
    "imgly--typo-h1": "imgly--typo-h1",
    "imgly--typo-h2": "imgly--typo-h2",
    "imgly--typo-h2-body-text": "imgly--typo-h2-body-text",
    "imgly--typo-h3": "imgly--typo-h3",
    "imgly--typo-h3-body-text": "imgly--typo-h3-body-text",
    "imgly--typo-h4": "imgly--typo-h4",
    "imgly--typo-h5": "imgly--typo-h5",
    "imgly--typo-h5-is-small": "imgly--typo-h5-is-small",
    "imgly--typo-paragraph-big": "imgly--typo-paragraph-big",
    "imgly--typo-paragraph": "imgly--typo-paragraph",
    "imgly--typo-paragraph-body-text": "imgly--typo-paragraph-body-text",
    "imgly--typo-paragraph-small": "imgly--typo-paragraph-small",
    "imgly--typo-link": "imgly--typo-link",
    "imgly--typo-subline": "imgly--typo-subline",
    "imgly--typo-subline-body-text": "imgly--typo-subline-body-text",
    "imgly--typo-overline": "imgly--typo-overline",
    "imgly--typo-overline-small": "imgly--typo-overline-small",
    "imgly--typo-button": "imgly--typo-button",
    "imgly--typo-button-small": "imgly--typo-button-small",
    "imgly--typo-icon": "imgly--typo-icon",
    root: S1,
    description: N1,
    options: I1,
    options__is_disabled: M1,
    options__is_small: H1,
    label: $1,
    radio: D1,
    button: V1,
    button__is_icon_button: P1,
    button__is_small: A1,
    button__content: F1,
    button__is_primary: R1,
    button__is_secondary: Z1,
    button__is_tertiary: T1,
    button__is_text: B1,
    button__is_disabled: G1
  },
  Y1 = _ref50 => {
    let {
      options: e,
      value: o,
      name: i,
      label: l,
      disabled: a,
      small: n = !0,
      hideLabel: r = !1,
      activeTheme: g = f.Secondary,
      onChange: y,
      render: p,
      className: u = ""
    } = _ref50;
    const b = be({
        value: o,
        setValue: y
      }),
      E = b.useState("value"),
      C = h => i + h.value;
    return /* @__PURE__ */t.createElement("div", {
      className: c(I.root, u)
    }, l && !r && /* @__PURE__ */t.createElement("span", {
      className: I.description
    }, l), /* @__PURE__ */t.createElement(Ce, {
      "aria-label": l,
      className: c(I.options, {
        [I.options__is_small]: n,
        [I.options__is_disabled]: a
      }),
      store: b
    }, e.map(h => {
      let V = f.Text;
      return !a && E === h.value && (V = g || f.Secondary), /* @__PURE__ */t.createElement("label", {
        key: C(h),
        className: I.label
      }, /* @__PURE__ */t.createElement(ve, {
        className: I.radio,
        value: h.value,
        "aria-label": h.label,
        render: p
      }), /* @__PURE__ */t.createElement("div", {
        className: c(I.button, I["button__is_".concat(V)], {
          [I.button__is_small]: n,
          [I.button__is_disabled]: a
        })
      }, /* @__PURE__ */t.createElement("span", {
        className: I.button__content
      }, h.label)));
    })));
  },
  q1 = _ref51 => {
    let {
      theme: e = f.Text,
      ...o
    } = _ref51;
    return /* @__PURE__ */t.createElement(_, null, /* @__PURE__ */t.createElement(M, {
      ...o,
      render: /* @__PURE__ */t.createElement("a", null),
      href: m.Blog.url,
      theme: e
    }, m.Blog.name));
  };
export { M as Button, f as ButtonTheme, Ha as CookieContext, W1 as Cookies, O1 as Footer, j1 as Header, q1 as HeaderBlogButton, Vl as HeaderCareers, xa as HeaderChildren, qt as HeaderContactSalesButton, Fl as HeaderContainer, Jt as HeaderFreeTrialButton, Bl as HeaderLogo, ro as HeaderMenu, Ma as HeaderMenuChildren, Qt as HeaderPricingButton, po as HeaderWrapper, Y1 as SegmentedControl, z1 as Select, Ja as ToggleCheckbox, go as useHeaderEvents };